var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _g, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _g2, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _g3, _path294, _path295, _g4, _path296, _path297, _g5, _path298, _path299, _g6, _path300, _path301, _g7, _path302, _path303, _g8, _path304, _path305, _g9, _path306, _path307, _g10, _path308, _path309, _g11, _path310, _path311, _g12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroHireDedicatedHeroDevelopers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 530,
    viewBox: "0 0 800 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_1548)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770 0H30C13.4315 0 0 13.4315 0 30V500C0 516.569 13.4315 530 30 530H770C786.569 530 800 516.569 800 500V30C800 13.4315 786.569 0 770 0Z",
    fill: "#F9FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.456 431.696C329.953 468.121 443.383 413.749 479.809 310.251C516.234 206.754 461.862 93.3239 358.364 56.8985C254.867 20.473 141.437 74.8455 105.011 178.343C68.586 281.84 122.959 395.27 226.456 431.696Z",
    stroke: "#EFFAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M594.43 422.699H630.309V424.83H594.43V422.699Z",
    fill: "#E2D2CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M625.499 527.234H622.355V430.374H625.499V527.234Z",
    fill: "#706865"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M575.105 422.096H600.045V425.139H575.105V422.096Z",
    fill: "#CCBDB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M582.848 424.83H592.291V396.144H582.848V424.83Z",
    fill: "#4667A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M505 430.375H643.178V424.868H505V430.375Z",
    fill: "#B59074"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M669.697 391.531C669.697 391.531 671.208 412.725 667.067 415.262C664.473 416.851 654.13 422.209 654.436 423.214C654.742 424.219 660.277 432.156 660.277 432.156C660.277 432.156 680.144 419.075 680.785 414.951C681.411 410.924 679.806 383.92 677.077 382.676C675.031 381.743 673.951 382.514 671.375 384.428C667.756 387.115 669.697 391.531 669.697 391.531Z",
    fill: "#52AAF3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M645.25 514.01C645.25 514.01 645.867 518.297 645.946 518.942C646.022 519.586 652.817 518.562 652.817 518.562L653.367 513.457C653.367 513.457 646.099 513.404 645.25 514.01Z",
    fill: "#424773"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M645.875 518.396C645.875 518.396 643.721 520.981 641.639 522.107C639.558 523.232 636.285 523.679 635.053 524.845C634.164 525.687 631.816 529.308 640.465 529.236C649.113 529.162 653.282 529.747 654.209 528.358C655.136 526.97 652.869 518.105 652.869 518.105C652.869 518.105 650.82 518.842 645.875 518.396Z",
    fill: "#292C47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M601.715 514.051C601.715 514.051 602.333 518.339 602.409 518.982C602.486 519.627 609.282 518.603 609.282 518.603L609.833 513.498C609.833 513.498 602.565 513.446 601.715 514.051Z",
    fill: "#424773"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M602.339 518.436C602.339 518.436 600.185 521.021 598.101 522.146C596.02 523.272 588.357 524.198 587.125 525.365C586.238 526.204 584.759 529.593 596.927 529.276C605.573 529.051 609.747 529.787 610.672 528.398C611.6 527.01 609.332 518.146 609.332 518.146C609.332 518.146 607.402 518.933 602.339 518.436Z",
    fill: "#292C47"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M667.171 439.935C667.171 439.935 642.465 444.115 636.885 444.991C631.305 445.867 601.049 453.396 597.266 455.69C594.255 457.516 598.845 501.373 599.918 518.105H611.835L612.699 467.913C627 468.272 637.205 464.569 647.618 466.15C658.031 467.731 666.713 469.979 673.331 461.103C673.331 461.103 673.575 441.872 667.171 439.935Z",
    fill: "#292C47"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M642.823 518.146L654.437 517.427L655.568 467.912C661.725 468.067 663.835 467.676 668.819 467.073L678.193 445.276C669.976 446.92 643.647 453.56 640.136 455.69C637.124 457.517 641.751 501.414 642.823 518.146Z",
    fill: "#292C47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M655.801 347.329C655.801 347.329 646.745 344.827 643.289 351.857C639.835 358.888 641.401 372.217 645.965 373.47C650.53 374.725 657.092 373.28 658.988 368.904C660.882 364.529 662.394 358.311 661.941 354.284C661.488 350.258 658.207 348.291 655.801 347.329Z",
    fill: "#EEA886"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M648.33 372.066C648.33 372.066 648.43 377.413 647.839 378.553C647.25 379.693 660.452 379.405 660.452 379.405C660.452 379.405 658.371 372.986 659.551 367.515C660.719 362.102 648.33 372.066 648.33 372.066Z",
    fill: "#EEA886"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M660.26 365.492C660.26 365.492 659.554 366.925 656.138 366.693C652.721 366.462 648.214 362.341 646.765 361.972C645.313 361.605 645.227 360.779 645.227 360.779L644.459 362.142L642.974 362.369C642.974 362.369 643.983 358.237 641.782 356.783C639.581 355.328 642.773 343.612 653.915 346.438C653.915 346.438 662.418 347.994 662.532 352.744C662.646 357.491 661.911 362.976 660.26 365.492Z",
    fill: "#3A3F47"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M647.148 378.416C647.148 378.416 647.186 376.238 648.172 376.028C649.161 375.82 658.549 374.528 659.76 375.004L660.281 377.88C660.281 377.88 657.946 379.317 647.148 378.416Z",
    fill: "#E2D2CA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M644.43 359.804C644.682 358.019 646.712 355.97 647.875 358.75C649.037 361.529 647.091 365.58 645.786 365.363C644.483 365.144 644.087 362.226 644.43 359.804Z",
    fill: "#EEA886"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M607.814 404.149C607.818 404.146 607.825 404.145 607.829 404.146C607.763 404.177 607.753 404.178 607.814 404.149Z",
    fill: "#323657"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M658.445 348.603C658.445 348.603 669.487 348.084 660.372 365.32L658.445 348.603Z",
    fill: "#3A3F47"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M683.042 524.022L682.22 526.332L647.512 515.58L649.176 510.899L683.042 524.022Z",
    fill: "#918783"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M646.324 513.93H650.269V476.194H646.324V513.93Z",
    fill: "#918783"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M636.664 476.414H659.932V474.19H636.664V476.414Z",
    fill: "#5E5854"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M613.242 524.022L614.064 526.332L648.772 515.58L647.247 510.606L613.242 524.022Z",
    fill: "#918783"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M637.699 526.085V528.771L648.774 515.578L647.249 510.604L637.699 526.085Z",
    fill: "#918783"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M610 527.233C610 529.025 611.453 530.477 613.243 530.477C615.035 530.477 616.488 529.025 616.488 527.233C616.488 525.442 615.035 523.99 613.243 523.99C611.453 523.99 610 525.442 610 527.233Z",
    fill: "#BFB2AC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M637.426 527.233C637.426 529.025 638.878 530.477 640.67 530.477C642.462 530.477 643.913 529.025 643.913 527.233C643.913 525.442 642.462 523.99 640.67 523.99C638.878 523.99 637.426 525.442 637.426 527.233Z",
    fill: "#BFB2AC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M679.801 527.233C679.801 529.025 681.253 530.477 683.045 530.477C684.837 530.477 686.288 529.025 686.288 527.233C686.288 525.442 684.837 523.99 683.045 523.99C681.253 523.99 679.801 525.442 679.801 527.233Z",
    fill: "#BFB2AC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M624.735 474.189H671.542C673.839 474.189 675.699 472.329 675.699 470.032V469.925C675.699 467.63 673.839 465.767 671.542 465.767H624.735C622.439 465.767 620.578 467.63 620.578 469.925V470.032C620.578 472.329 622.439 474.189 624.735 474.189Z",
    fill: "#E2D2CA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M522.676 527.234H525.818V430.374H522.676V527.234Z",
    fill: "#706865"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M550.949 409.965H624.2C626.491 409.965 628.349 408.108 628.349 405.818V356.585C628.349 354.294 626.491 352.436 624.2 352.436H550.949C548.657 352.436 546.801 354.294 546.801 356.585V405.818C546.801 408.108 548.657 409.965 550.949 409.965Z",
    fill: "#5F8BE3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M550 401.403H625.161V356H550V401.403Z",
    fill: "#F5F7FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M549.996 359.158H625.157V355.545H549.996V359.158Z",
    fill: "#CECFD6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M555.34 398.154H559.268C560.686 398.154 561.835 397.006 561.835 395.588V364.447C561.835 363.029 560.686 361.879 559.268 361.879H555.34C553.922 361.879 552.773 363.029 552.773 364.447V395.588C552.773 397.006 553.922 398.154 555.34 398.154Z",
    fill: "#CECFD6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M607.886 365.238H621.643C622.41 365.238 623.03 364.618 623.03 363.854V363.264C623.03 362.499 622.41 361.879 621.643 361.879H607.886C607.12 361.879 606.5 362.499 606.5 363.264V363.854C606.5 364.618 607.12 365.238 607.886 365.238Z",
    fill: "#CECFD6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M609.363 399.08H620.166C621.748 399.08 623.03 397.799 623.03 396.218V370.354C623.03 368.773 621.748 367.491 620.166 367.491H609.363C607.782 367.491 606.5 368.773 606.5 370.354V396.218C606.5 397.799 607.782 399.08 609.363 399.08Z",
    fill: "#CECFD6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M584.945 405.189C584.945 406.643 586.123 407.82 587.576 407.82C589.029 407.82 590.206 406.643 590.206 405.189C590.206 403.737 589.029 402.559 587.576 402.559C586.123 402.559 584.945 403.737 584.945 405.189Z",
    fill: "#5C5552"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M570.691 424.941V423.919C570.691 423.919 572.13 417.551 582.311 417.551C592.49 417.551 592.285 424.941 592.285 424.941H570.691Z",
    fill: "#2E436E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M592.408 418.495C592.408 418.495 590.195 418.322 589.385 417.834C588.576 417.345 583.727 414.085 582.589 414.606C581.45 415.129 573.872 417.45 574.136 418.558C574.399 419.666 575.099 419.559 575.634 419.363C576.169 419.167 581.672 418.012 582.157 418.207C582.157 418.207 576.752 420.178 576.732 421.617C576.709 423.057 577.862 423.406 578.374 423.95C578.886 424.494 579.502 425.846 580.895 425.948C582.288 426.052 589.085 423.689 590.482 423.58C591.881 423.471 594.472 423.667 594.647 423.439C594.824 423.21 592.408 418.495 592.408 418.495Z",
    fill: "#EEA886"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M632.669 381.435C639.721 380.195 647.143 378.417 647.143 378.417L660.275 377.881C660.275 377.881 672.329 380.534 677.075 382.678C677.525 382.881 677.527 393.431 678.763 396.196L674.828 404.499C674.828 404.499 672.554 420.945 672.082 428.259C671.866 431.617 672.695 460.71 672.695 460.71C672.695 460.71 671.515 461.292 662.553 462.281C653.59 463.268 631.196 461.923 631.054 460.866C630.914 459.806 635.391 421.447 635.59 419.46C635.894 416.412 634.709 402.323 634.709 402.323C633.02 404.591 628.716 414.835 624.227 419.709C621.589 422.576 608.517 424.335 606.054 424.417C600.692 424.596 590.908 425.663 590.622 425.141C590.395 424.828 589.77 416.458 590.383 416.253C590.92 416.074 609.086 415.028 613.74 412.559C615.443 411.656 620.533 400.557 620.533 400.557C620.533 400.557 628.78 383.183 632.669 381.435Z",
    fill: "#52AAF3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M658.553 459.869H680.6C685.007 459.869 688.583 456.293 688.583 451.886V415.204C688.583 410.795 685.007 407.221 680.6 407.221H658.553C654.144 407.221 650.57 410.795 650.57 415.204V451.886C650.57 456.293 654.144 459.869 658.553 459.869Z",
    fill: "#E2D2CA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M657.306 472.094C662.91 472.094 667.455 470.212 670.819 466.499C678.418 458.11 677.051 443.361 676.99 442.738C676.874 441.575 675.837 440.725 674.676 440.842C673.515 440.957 672.665 441.992 672.78 443.155C672.797 443.322 674.008 456.69 667.675 463.669C665.114 466.492 661.722 467.864 657.306 467.864C656.138 467.864 655.191 468.811 655.191 469.978C655.191 471.147 656.138 472.094 657.306 472.094Z",
    fill: "#E2D2CA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M727.051 512.461L726.802 512.447C726.807 512.356 727.281 503.239 727.149 492.518C727.027 482.629 726.352 469.316 723.816 462.054L724.051 461.973C726.596 469.266 727.276 482.609 727.397 492.516C727.53 503.245 727.056 512.37 727.051 512.461Z",
    fill: "url(#paint0_linear_41_1548)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M730.649 512.461C730.619 511.875 727.613 453.714 723.812 436.207L724.056 436.155C727.86 453.682 730.867 511.863 730.898 512.448L730.649 512.461Z",
    fill: "url(#paint1_linear_41_1548)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M729.253 514.402C729.226 513.886 726.661 462.604 728.67 452.247L728.915 452.295C726.911 462.622 729.475 513.874 729.502 514.39L729.253 514.402Z",
    fill: "url(#paint2_linear_41_1548)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M729.088 513.271H728.84C728.84 512.984 728.867 484.289 731.193 471.193L731.438 471.236C729.115 484.311 729.088 512.984 729.088 513.271Z",
    fill: "url(#paint3_linear_41_1548)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M749.256 459.96C749.256 459.96 746.691 442.505 740.278 450.78C735.851 456.494 732.96 464.559 731.595 469.005C730.997 470.953 730.636 472.966 730.517 475L730.23 479.893C744.143 443.621 749.256 459.96 749.256 459.96Z",
    fill: "url(#paint4_linear_41_1548)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M752.499 439.036C752.499 439.036 755.068 422.343 740.5 429.786C726.541 436.919 728.103 458.363 728.103 458.363C728.94 454.786 730.45 445.228 735.437 439.036C748.65 422.635 752.499 439.036 752.499 439.036Z",
    fill: "url(#paint5_linear_41_1548)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M737.989 492.49C729.681 490.853 729.23 497.965 729.23 497.965V500.572C729.933 496.081 737.989 492.49 737.989 492.49Z",
    fill: "url(#paint6_linear_41_1548)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M717.504 420.705C709.382 414.621 705 420.705 705 420.705C705 420.705 720.613 421.462 726.54 455.828C726.54 455.828 725.626 426.789 717.504 420.705Z",
    fill: "url(#paint7_linear_41_1548)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M710.773 445.258C710.773 445.258 723.797 462.119 726.416 475.889L726.128 472.669C726.128 472.669 725.612 448.212 710.773 445.258Z",
    fill: "url(#paint8_linear_41_1548)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M716.328 481.976C716.328 481.976 726.6 492.65 727.288 494.893C727.288 494.893 723.167 482.616 716.328 481.976Z",
    fill: "url(#paint9_linear_41_1548)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M737.355 533.525L741.07 511.109H716.613L720.327 533.525H737.355Z",
    fill: "#DFDFDF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M743.369 511.107H714.316V505.098H743.369V511.107Z",
    fill: "url(#paint10_linear_41_1548)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M741.07 511.109H716.613L720.327 533.525H724.508C724.508 533.525 720.42 516.127 740.268 515.947L741.07 511.109Z",
    fill: "#DFDFDF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M392.121 385.887H429.874V271.216H392.121V385.887Z",
    fill: "#4DA8F2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M264.58 326.453H557.42C566.578 326.453 574 319.029 574 309.872V113.056C574 103.9 566.578 96.4763 557.42 96.4763H264.58C255.423 96.4763 248 103.9 248 113.056V309.872C248 319.029 255.423 326.453 264.58 326.453Z",
    fill: "#B5DEFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M260.766 290.414H561.232V72.0001H260.766V290.414Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M260.766 98.3827H561.232V72.0024H260.766V98.3827Z",
    fill: "url(#paint11_linear_41_1548)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M400.484 306.906C400.484 312.713 405.191 317.422 411 317.422C416.808 317.422 421.515 312.713 421.515 306.906C421.515 301.098 416.808 296.39 411 296.39C405.191 296.39 400.484 301.098 400.484 306.906Z",
    fill: "#4DA8F2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M362.18 124.961H451.921C453.938 124.961 455.571 123.327 455.571 121.312V120.792C455.571 118.777 453.938 117.143 451.921 117.143H362.18C360.165 117.143 358.531 118.777 358.531 120.792V121.312C358.531 123.327 360.165 124.961 362.18 124.961Z",
    fill: "#DFE1E8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M362.18 139.061H451.921C453.938 139.061 455.571 137.427 455.571 135.411V134.892C455.571 132.877 453.938 131.243 451.921 131.243H362.18C360.165 131.243 358.531 132.877 358.531 134.892V135.411C358.531 137.427 360.165 139.061 362.18 139.061Z",
    fill: "#DFE1E8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M362.18 153.158H451.921C453.938 153.158 455.571 151.524 455.571 149.509V148.991C455.571 146.975 453.938 145.341 451.921 145.341H362.18C360.165 145.341 358.531 146.975 358.531 148.991V149.509C358.531 151.524 360.165 153.158 362.18 153.158Z",
    fill: "#DFE1E8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M291.711 174.605C283.497 174.605 276.815 181.289 276.815 189.504V258.014C276.815 266.229 283.497 272.912 291.711 272.912H404.341C412.555 272.912 419.238 266.229 419.238 258.014V189.504C419.238 181.289 412.555 174.605 404.341 174.605H291.711ZM404.341 275.047H291.711C282.321 275.047 274.68 267.407 274.68 258.014V189.504C274.68 180.111 282.321 172.471 291.711 172.471H404.341C413.733 172.471 421.373 180.111 421.373 189.504V258.014C421.373 267.407 413.733 275.047 404.341 275.047Z",
    fill: "#DFE1E8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M300.616 198.291H395.428C399.582 198.291 402.95 194.923 402.95 190.769V189.337C402.95 185.183 399.582 181.816 395.428 181.816H300.616C296.461 181.816 293.094 185.183 293.094 189.337V190.769C293.094 194.923 296.461 198.291 300.616 198.291Z",
    fill: "#DFE1E8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M495.921 390.217H326.074V381.56H495.921V390.217Z",
    fill: "#B5DEFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M519.832 228.242L519.839 228.24C521.399 227.723 522.887 227.045 524.284 226.228C531.234 222.155 535.897 214.612 535.897 205.98C535.897 193.031 525.399 182.532 512.45 182.532C499.499 182.532 489 193.031 489 205.98C489 215.185 494.305 223.152 502.027 226.991C505.166 228.551 508.703 229.428 512.45 229.428C514.876 229.428 517.216 229.06 519.415 228.377H519.416C519.557 228.333 519.696 228.289 519.832 228.242Z",
    stroke: "#B5DEFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M312.585 90.1738H276.897C274.917 90.1738 273.312 88.5699 273.312 86.5903V83.7891C273.312 81.8096 274.917 80.2045 276.897 80.2045H312.585C314.564 80.2045 316.168 81.8096 316.168 83.7891V86.5903C316.168 88.5699 314.564 90.1738 312.585 90.1738Z",
    fill: "#F5F7FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M282.205 135.763C282.269 130.833 284.639 126.471 288.277 123.695C290.928 121.669 294.247 120.484 297.837 120.53C304.439 120.614 310.018 124.832 312.147 130.691L312.151 130.699C312.656 132.094 312.966 133.579 313.05 135.127C313.068 135.469 313.073 135.813 313.071 136.161C313.025 139.65 311.825 142.851 309.841 145.41C306.977 149.104 302.475 151.458 297.442 151.393C295.777 151.371 294.181 151.088 292.688 150.583C286.523 148.498 282.118 142.626 282.205 135.763ZM291.038 155.463C293.027 156.138 295.158 156.514 297.374 156.543C304.088 156.629 310.094 153.492 313.914 148.567C316.563 145.152 318.163 140.879 318.22 136.226C318.226 135.764 318.217 135.303 318.193 134.848C318.083 132.78 317.667 130.795 316.99 128.931C314.151 121.118 306.709 115.493 297.905 115.379C293.16 115.317 288.773 116.865 285.257 119.518C280.345 123.221 277.14 129.074 277.056 135.698C276.939 144.848 282.811 152.681 291.038 155.463Z",
    fill: "#78C2FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M309.836 145.411L313.908 148.566C310.088 153.492 304.083 156.629 297.368 156.543C295.152 156.515 293.022 156.138 291.031 155.463L292.684 150.584C294.177 151.088 295.774 151.371 297.435 151.392C302.469 151.457 306.97 149.104 309.836 145.411Z",
    fill: "#1A598C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M313.043 135.127L318.188 134.848C318.212 135.303 318.222 135.764 318.215 136.226C318.156 140.88 316.557 145.152 313.908 148.566L309.836 145.411C311.821 142.852 313.019 139.649 313.065 136.161C313.069 135.814 313.061 135.468 313.043 135.127Z",
    fill: "#2273B5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M313.048 135.125C312.964 133.577 312.654 132.091 312.149 130.697L312.145 130.689L316.988 128.929C317.665 130.792 318.081 132.778 318.191 134.846L313.048 135.125Z",
    fill: "#2273B5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M285.258 119.518C288.774 116.865 293.161 115.317 297.906 115.379C306.71 115.493 314.152 121.118 316.991 128.931L312.152 130.699L312.148 130.691C310.019 124.832 304.44 120.614 297.838 120.53C294.248 120.484 290.929 121.669 288.278 123.695L285.258 119.518Z",
    fill: "#4DA8F2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M450.773 196.471H437.439C434.789 196.471 432.641 194.322 432.641 191.672V178.338C432.641 175.689 434.789 173.54 437.439 173.54H450.773C453.424 173.54 455.571 175.689 455.571 178.338V191.672C455.571 194.322 453.424 196.471 450.773 196.471Z",
    fill: "#78C2FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M443.38 190.057L437.583 185.003C437.108 184.588 437.058 183.867 437.473 183.392C437.887 182.917 438.608 182.868 439.083 183.282L443.182 186.855L449.027 180.335C449.45 179.865 450.172 179.827 450.641 180.247C451.111 180.668 451.149 181.39 450.728 181.86L443.38 190.057Z",
    fill: "#F3F3F3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M450.773 225.852H437.439C434.789 225.852 432.641 223.704 432.641 221.053V207.72C432.641 205.071 434.789 202.922 437.439 202.922H450.773C453.424 202.922 455.571 205.071 455.571 207.72V221.053C455.571 223.704 453.424 225.852 450.773 225.852Z",
    fill: "#78C2FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M443.38 219.436L437.583 214.382C437.108 213.967 437.058 213.246 437.473 212.771C437.887 212.296 438.608 212.246 439.083 212.66L443.182 216.234L449.027 209.714C449.45 209.244 450.172 209.205 450.641 209.626C451.111 210.046 451.149 210.768 450.728 211.238L443.38 219.436Z",
    fill: "#F3F3F3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M450.773 255.232H437.439C434.789 255.232 432.641 253.084 432.641 250.434V237.101C432.641 234.45 434.789 232.303 437.439 232.303H450.773C453.424 232.303 455.571 234.45 455.571 237.101V250.434C455.571 253.084 453.424 255.232 450.773 255.232Z",
    fill: "#78C2FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M359.997 391.013C359.997 391.013 360.689 395.661 361.153 397.643C361.616 399.625 365.902 405.31 365.827 406.278C365.751 407.244 363.937 408.384 363.025 407.605C362.113 406.827 356.057 400.604 354.763 397.938C353.468 395.273 349.185 391.798 348.747 390.614C348.31 389.43 353.799 385.968 355.212 385.416C356.626 384.863 359.997 391.013 359.997 391.013Z",
    fill: "#1D2033"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M349.262 308.322C349.262 308.322 349.829 311.286 350.246 311.834C350.663 312.382 351.79 315.138 351.903 315.526C352.017 315.913 352.71 318.696 352.827 319.048C352.944 319.401 352.153 319.95 351.611 319.206C351.274 318.744 350.684 316.943 350.444 316.361C350.203 315.78 349.466 313.94 349.266 314.275C349.067 314.612 349.115 317.078 349.082 317.713C349.05 318.347 349.452 320.298 349.641 321.105C349.83 321.913 350.905 325.299 350.473 325.481C350.042 325.664 349.678 325.614 349.122 324.705C349.122 324.705 348.241 325.198 347.728 324.083C347.728 324.083 346.939 324.369 346.452 322.916C346.452 322.916 345.891 322.609 345.674 322.088C345.457 321.567 344.18 317.113 344.191 315.295C344.202 313.48 344.629 312.213 344.551 310.932C344.473 309.648 343.816 306.906 343.816 306.906L349.262 308.322Z",
    fill: "#EEA886"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M356.857 384.688L355.207 385.417L359.992 391.014L361.577 389.259L356.857 384.688Z",
    fill: "#50558A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M373.587 396.419C373.587 396.419 372.522 398.986 371.624 400.003C370.727 401.022 367.288 402.841 367.27 405.863C367.25 409.141 373.066 408.23 375.34 408.111C377.614 407.99 377.787 406.24 378.744 404.384C379.703 402.529 380.668 402.844 380.847 401.346C381.027 399.85 380.114 396.499 380.114 396.499L373.587 396.419Z",
    fill: "#1D2033"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M373.49 395.468L373.324 397.023C373.324 397.023 376.902 398.309 380.284 397.158L380.095 395.033L373.49 395.468Z",
    fill: "#50558A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M375.467 353.061C375.366 347.637 372.953 317.237 373.208 317.237C374.396 317.237 381.085 346.187 381.333 350.261C381.385 351.095 380.341 352.962 378.655 355.418C377.897 356.524 377.008 357.748 376.03 359.052L376.028 359.054C375.696 356.074 375.482 353.883 375.467 353.061ZM393.325 355.98C393.325 351.94 390.376 316.687 390.51 315.34C390.599 314.461 389.661 306.021 388.997 300.256C388.992 300.206 388.986 300.156 388.979 300.108C388.979 300.096 388.976 300.085 388.976 300.073C388.788 298.454 388.626 297.057 388.516 296.12C388.465 295.687 388.425 295.351 388.4 295.138C388.379 294.961 388.368 294.868 388.368 294.868C388.368 294.868 369.342 291.116 359.477 294.661C359.065 294.81 358.67 294.97 358.292 295.144C358.292 295.144 358.268 295.312 358.225 295.628C358.126 296.357 357.92 297.878 357.646 299.945C357.599 300.293 357.551 300.656 357.5 301.035C356.096 311.664 356.998 323.215 359.455 335.041C361.867 346.641 363.193 355.317 363.441 357.001C363.769 359.213 364.736 365.294 365.807 371.964C360.571 378.422 356.106 383.914 356.439 384.46C357.266 385.81 364.613 393.417 365.017 392.07C365.017 392.07 366.344 390.568 368.422 388.173C369.083 392.253 369.536 395.037 369.536 395.037C369.536 395.037 377.589 396.961 380.553 395.209C380.553 395.209 379.388 386.36 378.173 376.739C385.566 367.888 393.325 358.096 393.325 355.98Z",
    fill: "#292C47"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M396.501 244.441L391.385 262.796C391.21 263.39 391 264.123 390.777 264.976L390.769 265.008C390.766 265.015 390.764 265.022 390.763 265.03C389.909 268.302 388.853 273.289 388.538 278.83C388.325 282.608 389.025 297.795 389.025 297.795C389.025 297.795 381.282 300.683 369.698 299.952C369.698 299.952 357.237 299.66 358.253 292.02C360.942 271.799 358.312 263.462 357.96 261.432C357.96 261.432 356.269 251.61 355.059 243.38C358.564 242.075 373.544 237.039 373.544 237.039L381.303 237.62C381.303 237.62 393.095 240.523 396.501 244.441Z",
    fill: "#D9C7C1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M377.441 211.091C377.441 211.091 385.015 212.369 383.73 224.226C382.446 236.084 375.761 235.037 375.313 235.021C374.866 235.004 368.589 235.164 368.258 220.666C368.258 220.666 368.161 209.948 377.441 211.091Z",
    fill: "#EEA987"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M380.76 231.585C380.76 231.585 380.499 236.465 380.959 237.528C381.421 238.589 374.878 241.949 370.812 238.122C370.812 238.122 371.635 232.787 371.38 230.903C371.124 229.02 380.76 231.585 380.76 231.585Z",
    fill: "#EEA987"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M383.882 220.877C383.882 220.877 384.723 219.999 385.017 220.899C385.312 221.802 383.675 225.798 383.777 225.979C383.777 225.979 383.622 226.327 383.424 226.133C383.227 225.939 383.882 220.877 383.882 220.877Z",
    fill: "#EEA987"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M368.342 220.553C368.342 220.553 367.538 219.641 367.206 220.53C366.874 221.418 368.086 225.409 368.236 225.655C368.236 225.655 368.497 226.065 368.702 225.879C368.907 225.694 368.342 220.553 368.342 220.553Z",
    fill: "#EEA987"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M384.365 219.868C384.104 221.49 383.857 222.696 383.857 222.696L382.755 224.136C382.755 224.136 382.82 220.953 382.651 220.453C382.588 220.263 382.512 219.927 382.435 219.564C382.309 218.964 382.18 218.286 382.091 218.061C381.949 217.701 375.599 215.846 369.944 218.45C369.944 218.45 369.993 218.94 369.989 219.487C369.987 220.122 369.917 220.834 369.625 220.94C369.084 221.139 369.31 224.666 369.31 224.666L368.428 223.648C368.428 223.648 368.173 221.806 367.922 219.688C367.922 219.688 367.921 219.684 367.921 219.674C367.864 219.18 367.806 218.671 367.75 218.168C367.624 216.037 367.835 212.17 370.608 209.898C372.48 209.096 375.468 208.416 380.449 209.941C380.449 209.941 381.591 210.018 381.911 210.326C385.014 213.74 384.365 219.868 384.365 219.868Z",
    fill: "#E8734D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M371.895 233.436C371.895 233.436 373.103 235.115 375.912 235.051C378.72 234.988 379.938 233.524 379.938 233.524C379.938 233.524 378.609 236.304 375.898 236.275C373.186 236.245 371.895 233.436 371.895 233.436Z",
    fill: "#C78D71"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M370.039 238.224C370.039 238.224 372.069 241.757 375.921 242.089C378.363 242.301 380.478 239.205 381.469 237.684C381.469 237.684 375.999 235.342 370.039 238.224Z",
    fill: "#EEA987"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M380.76 236.568C380.76 236.568 379.212 238.597 375.914 240.768L377.965 243.928L381.463 237.685L380.76 236.568Z",
    fill: "#EDDAD3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M370.963 237.042C370.963 237.042 372.933 239.512 375.918 240.769L373.667 244.023L369.73 238.329L370.963 237.042Z",
    fill: "#EDDAD3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M375.91 240.766L377.667 243.44C377.667 243.44 375.821 244.484 374.105 243.373L375.91 240.766Z",
    fill: "#5073AB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M357.836 301.329C357.836 301.329 367.339 304.835 388.83 301.532L388.545 297.641C388.545 297.641 376.088 301.317 358.216 298.169L357.836 301.329Z",
    fill: "#1D2033"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M381.461 237.684C381.461 237.684 379.24 254.283 379.544 268.601C379.848 282.919 390.663 308.92 390.663 308.92C390.663 308.92 395.39 304.349 397.447 301.76C397.447 301.76 390.088 280.526 390.223 276.695C390.358 272.865 398.528 243.943 398.528 243.943C398.528 243.943 393.988 240.982 381.461 237.684Z",
    fill: "#323657"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M369.536 238.386C369.536 238.386 369.554 254.284 369.249 268.602C368.945 282.92 367.059 309.574 367.059 309.574C367.059 309.574 356.474 307.899 354.417 305.31C354.417 305.31 358.705 280.526 358.57 276.696C358.435 272.866 351.676 244.688 351.676 244.688C351.676 244.688 355.61 242.101 369.536 238.386Z",
    fill: "#323657"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M376.623 303.182H370.785V298.84H376.623V303.182Z",
    fill: "#3A4066"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M375.091 242.765C375.091 242.765 372.482 251.666 372.254 269.345C372.027 287.022 372.575 292.092 372.575 292.092L374.611 296.119L377.324 291.916C377.324 291.916 376.454 251.237 376.957 243.074L375.091 242.765Z",
    fill: "#5073AB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M390.079 309.07C390.079 309.07 390.717 308.645 390.892 308.343C390.892 308.343 391.162 307.77 391.382 307.373C391.452 307.249 391.518 307.14 391.567 307.074C391.776 306.797 392.33 306.244 392.618 305.459C392.907 304.676 393.148 301.024 393.148 301.024L390.909 300.366L388.916 299.489C388.916 299.489 384.553 302.834 384.187 303.54C384.151 303.608 384.119 303.677 384.095 303.745C383.852 304.366 383.972 304.916 383.887 305.255C383.857 305.378 383.651 306.633 383.945 306.911C384.353 307.297 384.818 307.421 385.227 307.361C385.227 307.361 386.064 308.086 386.858 308.151C386.858 308.151 387.605 308.842 388.624 308.679C388.624 308.679 389.472 309.305 390.079 309.07Z",
    fill: "#EEA886"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M387.219 299.089C387.219 299.089 390.246 301.757 394.488 303.182C394.488 303.182 408.553 280.263 408.73 278.611C408.895 277.08 401.753 245.917 398.53 243.945L392.677 261.084C393.065 260.97 399.339 274.104 399.363 275.793C399.397 278.057 387.219 299.089 387.219 299.089Z",
    fill: "#323657"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M350.92 311.423C350.92 311.423 347.76 312.011 343.188 311.753C343.188 311.753 344.969 282.336 344.791 280.681C344.626 279.152 348.454 246.66 351.676 244.688L357.424 262.006C357.036 261.893 353.571 279.722 353.547 281.411C353.513 283.675 350.92 311.423 350.92 311.423Z",
    fill: "#323657"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M383.539 302.343L392.575 307.031L389.023 313.607L381.332 305.383L383.539 302.343Z",
    fill: "#292C47"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M378.656 355.417L377.743 373.301L376.031 359.052V359.051C377.009 357.747 377.898 356.523 378.656 355.417Z",
    fill: "#1D2033"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M338.446 138.024H333.172V155.32H338.446V138.024Z",
    fill: "#78C2FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M537.436 264.244C537.436 277.695 526.537 288.691 512.989 288.691C499.461 288.691 488.539 277.721 488.539 264.244C488.539 250.741 499.486 239.794 512.989 239.794C526.491 239.794 537.436 250.741 537.436 264.244Z",
    fill: "#EEF0F7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M329.798 142.876H324.523V155.32H329.798V142.876Z",
    fill: "#78C2FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M347.087 130.009H341.812V155.32H347.087V130.009Z",
    fill: "#78C2FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M512.993 273.992C512.314 273.992 511.762 273.44 511.762 272.76V255.727C511.762 255.048 512.314 254.497 512.993 254.497C513.674 254.497 514.225 255.048 514.225 255.727V272.76C514.225 273.44 513.674 273.992 512.993 273.992Z",
    fill: "#949494"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M521.506 265.477H504.474C503.793 265.477 503.242 264.925 503.242 264.244C503.242 263.564 503.793 263.014 504.474 263.014H521.506C522.187 263.014 522.737 263.564 522.737 264.244C522.737 264.925 522.187 265.477 521.506 265.477Z",
    fill: "#949494"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M480.907 502.605C480.907 502.605 479.675 500.591 477.987 499.805C476.299 499.021 472.838 501.761 472.535 503.285L468.523 509.138L469.283 509.659L471.425 506.535C469.966 510.043 467.883 514.244 469.346 516.355C471.31 519.19 475.766 522.055 476.941 521.559C478.119 521.064 477.883 512.822 477.883 512.822C476.613 505.547 480.907 502.605 480.907 502.605Z",
    fill: "#1D3B54"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M480.911 502.603C480.911 502.603 479.448 505.414 478.697 507.597C477.947 509.779 477.806 515.823 477.332 516.242C476.858 516.661 473.127 514.778 472.628 512.518C472.131 510.259 473.644 505.742 475.085 503.368C476.526 500.992 477.991 499.804 477.991 499.804C477.991 499.804 480.535 500.3 480.911 502.603Z",
    fill: "#DE9673"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M495.316 449.642C495.316 449.642 493.03 461.775 493.03 464.676C493.03 467.578 492.239 472.325 490.393 475.842C488.547 479.36 480.445 503.385 479.742 506.185C479.038 508.981 478.435 511.625 478.435 511.625C478.435 511.625 474.391 509.779 474.391 507.141C474.391 504.504 477.909 482.7 478.523 478.393C479.139 474.085 484.238 452.016 484.238 452.016L495.316 449.642Z",
    fill: "#DE9673"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M482.393 448.851C482.393 448.851 483.185 458.962 483.097 461.599C483.009 464.237 481.778 470.215 481.778 471.799C481.778 473.38 481.777 506.171 483.089 510.127C484.401 514.082 479.405 511.361 479.405 511.361C479.405 511.361 470.702 489.794 470.702 480.796C470.702 471.799 471.756 467.314 471.139 461.599C470.525 455.883 467.789 448.362 467.789 448.362L482.393 448.851Z",
    fill: "#EEA886"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M469.226 400.186C469.226 400.186 464.547 405.918 463.316 413.568C462.086 421.216 464.774 435.64 465.729 439.813C466.569 443.475 468.172 455.196 468.26 456.426C468.26 456.426 483.992 458.208 495.949 454.428C495.949 454.428 497.043 438.058 497.746 431.112C498.449 424.166 495.017 400.712 495.017 400.712L469.226 400.186Z",
    fill: "#FF6E53"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M487.214 520.102C481.579 515.181 483.087 510.128 483.087 510.128C483.087 510.128 480.834 509.328 479.006 509.784C477.176 510.241 476.196 514.604 476.927 515.998L477.496 523.164L478.425 523.088L478.123 519.264C479.209 522.956 480.243 527.592 482.741 528.323C486.094 529.304 491.428 528.723 492.039 527.583C492.65 526.443 487.214 520.102 487.214 520.102Z",
    fill: "#1D3B54"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M490.523 346.613C490.523 346.613 489.128 354.912 490.333 357.699C491.536 360.487 483.934 354.441 483.934 354.441C483.934 354.441 487.089 345.297 490.523 346.613Z",
    fill: "#754836"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M487.71 323.558C487.71 323.558 475.506 320.764 473.986 333.805C472.466 346.845 477.956 348.483 474.24 357.32C470.522 366.158 483.315 354.441 483.315 354.441L487.71 323.558Z",
    fill: "#754836"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M486.656 323.365C489.789 323.303 496.684 325.072 497.521 333.394C497.521 333.394 497.207 335.622 496.615 337.362C496.024 339.104 497.45 344.326 497.033 344.57C496.615 344.813 494.909 345.093 494.909 345.093C494.909 345.093 492.924 350.699 490.94 350.594C488.954 350.49 481.481 348.726 478.138 341.587C474.795 334.449 474.005 323.621 486.656 323.365Z",
    fill: "#EEA886"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M488.345 354.028C488.345 354.028 493.076 355.97 493.92 356.562C494.765 357.153 496.455 363.995 496.877 364.587C497.299 365.178 501.379 370.251 500.815 374.364C500.373 377.595 498.546 379.305 497.362 380.572C496.18 381.839 495.085 388.661 494.713 389.674C494.343 390.687 495.522 403.994 495.522 403.994C495.522 403.994 481.642 409.396 469.225 400.189C469.225 400.189 471.705 391.28 471.705 389.674C471.705 388.069 470.1 376.75 465.792 370.077C461.483 363.404 466.552 356.308 469.846 355.465C473.14 354.618 479.476 352.253 479.476 352.253L488.345 354.028Z",
    fill: "#F55F42"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M493.232 356.176C493.232 356.176 496.288 356.369 497.744 359.41C499.201 362.452 499.759 364.98 500.139 365.741C500.518 366.501 505.791 376.515 506.107 378.733C506.424 380.95 505.918 385.005 503.129 386.082C500.341 387.158 490.332 387.285 490.332 387.285C490.332 387.285 492.866 382.137 490.522 379.475C490.522 379.475 497.786 378.163 499.505 377.989C501.32 377.807 490.931 358.456 493.232 356.176Z",
    fill: "#F55F42"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M476.594 364.775L490.13 396.387L507.003 388.437L494.524 358.08L476.594 364.775Z",
    fill: "#1D3B54"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M484.351 380.303C484.351 380.303 482.519 380.79 481.939 380.875C481.359 380.958 482.076 382.033 482.788 382.066C483.5 382.098 484.351 380.303 484.351 380.303Z",
    fill: "#EEA886"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M485.589 389.301C485.589 389.301 486.439 389.259 486.802 389.059C486.802 389.059 487.434 388.644 487.901 388.378C488.05 388.294 488.182 388.222 488.271 388.186C488.646 388.034 489.513 387.812 490.309 387.193C491.103 386.576 493.692 384.109 493.692 384.109L491.981 381.529L490.659 379.477C490.659 379.477 485.096 379.629 484.288 380.119C484.21 380.167 484.134 380.219 484.065 380.272C483.422 380.753 483.145 381.382 482.836 381.672C482.724 381.779 481.674 382.925 481.737 383.385C481.825 384.023 482.144 384.43 482.543 384.62C482.543 384.62 482.77 385.862 483.416 386.413C483.416 386.413 483.588 387.565 484.59 388.02C484.59 388.02 484.896 389.17 485.589 389.301Z",
    fill: "#EEA886"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M490.523 379.477C490.523 379.477 498.764 378.005 501.039 377.764C501.039 377.764 501.195 374.872 500.779 372.422C500.364 369.971 498.351 366.683 498.351 366.683L502.565 370.543C502.565 370.543 506.03 377.182 506.108 378.735C506.186 380.287 506.597 382.683 504.547 385.113C502.497 387.541 492.819 386.43 492.819 386.43C492.819 386.43 493.627 383.45 490.523 379.477Z",
    fill: "#F55F42"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M487.986 349.272C487.986 349.272 487.72 350.058 487.41 351.226C487.25 351.824 487.081 352.521 486.928 353.263C486.51 355.318 486.23 357.724 486.72 359.345C486.72 359.345 482.286 360.742 478.992 354.44C478.992 354.44 480.67 347.795 478.849 343.686C477.027 339.58 487.986 349.272 487.986 349.272Z",
    fill: "#EEA886"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M497.52 333.396C497.52 333.396 492.343 336.714 487.282 337.272C482.222 337.829 479.407 345.482 479.407 345.482C479.407 345.482 471.451 333.094 477.858 325.48C484.264 317.865 498.888 323.762 497.52 333.396Z",
    fill: "#754836"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M485.199 336.98C485.199 336.004 484.154 334.509 482.518 335.797C480.882 337.086 482.901 341.786 484.224 341.368C485.547 340.951 485.199 337.99 485.199 336.98Z",
    fill: "#EEA886"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M488.624 354.142C488.624 354.142 490.709 360.298 485.832 360.265C480.953 360.235 478.83 356.398 477.438 352.995C477.438 352.995 479.686 351.904 480.731 351.745C481.776 351.587 488.624 354.142 488.624 354.142Z",
    fill: "#EEA886"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M483.086 510.128C483.086 510.128 483.727 513.274 484.525 515.472C485.324 517.669 489.063 522.518 488.956 523.15C488.851 523.783 484.711 524.677 482.881 523.215C481.049 521.752 479.362 517.23 478.985 514.442C478.607 511.653 478.807 509.854 478.807 509.854C478.807 509.854 481.323 508.552 483.086 510.128Z",
    fill: "#EEA886"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M487.801 349.91C487.641 350.508 487.407 351.227 487.224 351.939C483.22 349.235 481.301 346.023 481.301 346.023C483.573 348.197 487.801 349.91 487.801 349.91Z",
    fill: "#A77860"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M223.188 315.918H220.508V194.063H223.188V315.918Z",
    fill: "#706865"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M226.956 295.805H154.839C150.396 295.805 146.793 292.203 146.793 287.758V151.202C146.793 146.758 150.396 143.156 154.839 143.156H226.956C231.4 143.156 235.004 146.758 235.004 151.202V287.758C235.004 292.203 231.4 295.805 226.956 295.805Z",
    fill: "#BDAFAA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M224.634 289.844H157.165C152.775 289.844 149.215 286.284 149.215 281.893V153.567C149.215 149.176 152.775 145.616 157.165 145.616H224.634C229.025 145.616 232.584 149.176 232.584 153.567V281.893C232.584 286.284 229.025 289.844 224.634 289.844Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M204.043 147.936H177.758V142H204.043V147.936Z",
    fill: "#706865"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M163.168 239.029C159.402 239.029 156.339 242.093 156.339 245.859V276.237C156.339 280.003 159.402 283.066 163.168 283.066H216.532C220.297 283.066 223.362 280.003 223.362 276.237V245.859C223.362 242.093 220.297 239.029 216.532 239.029H163.168ZM216.532 284.076H163.168C158.846 284.076 155.328 280.56 155.328 276.237V245.859C155.328 241.536 158.846 238.019 163.168 238.019H216.532C220.855 238.019 224.372 241.536 224.372 245.859V276.237C224.372 280.56 220.855 284.076 216.532 284.076Z",
    fill: "#B5DEFF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M168.653 210.597C168.649 210.596 168.646 210.595 168.641 210.597C168.694 210.62 168.701 210.623 168.653 210.597Z",
    fill: "#323657"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M214.997 190.933C210.759 190.933 207.312 194.381 207.312 198.619C207.312 202.858 210.759 206.306 214.997 206.306C219.235 206.306 222.682 202.858 222.682 198.619C222.682 194.381 219.235 190.933 214.997 190.933ZM214.997 207.316C210.202 207.316 206.301 203.415 206.301 198.619C206.301 193.825 210.202 189.923 214.997 189.923C219.792 189.923 223.693 193.825 223.693 198.619C223.693 203.415 219.792 207.316 214.997 207.316Z",
    fill: "#B5DEFF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M214.997 210.972C210.759 210.972 207.312 214.42 207.312 218.658C207.312 222.896 210.759 226.344 214.997 226.344C219.235 226.344 222.682 222.896 222.682 218.658C222.682 214.42 219.235 210.972 214.997 210.972ZM214.997 227.354C210.202 227.354 206.301 223.452 206.301 218.658C206.301 213.863 210.202 209.961 214.997 209.961C219.792 209.961 223.693 213.863 223.693 218.658C223.693 223.452 219.792 227.354 214.997 227.354Z",
    fill: "#B5DEFF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M175.801 199.008C175.083 199.008 174.358 198.973 173.641 198.905C172.849 198.829 172.06 198.713 171.297 198.556C167.973 197.882 164.789 196.428 162.088 194.354C161.289 193.74 160.523 193.067 159.814 192.352C159.668 192.204 159.53 192.061 159.404 191.925C158.904 191.399 158.424 190.835 157.975 190.254C154.9 186.28 153.273 181.518 153.273 176.481C153.273 164.06 163.38 153.954 175.801 153.954V154.964C163.937 154.964 154.284 164.616 154.284 176.481C154.284 181.292 155.837 185.841 158.774 189.635C159.203 190.191 159.662 190.728 160.14 191.233C160.261 191.364 160.393 191.501 160.531 191.64C161.209 192.323 161.939 192.967 162.704 193.552C165.283 195.535 168.324 196.923 171.498 197.566C172.227 197.715 172.981 197.827 173.737 197.899C174.421 197.964 175.115 197.997 175.801 197.997C176.052 197.997 176.282 197.993 176.507 197.985C177.16 197.964 177.812 197.915 178.443 197.836C181.954 197.407 185.337 196.097 188.228 194.049C188.533 193.832 188.831 193.608 189.115 193.384C189.36 193.191 189.615 192.982 189.87 192.76C190.732 192.015 191.541 191.195 192.275 190.323C195.526 186.456 197.317 181.541 197.317 176.481C197.317 175.424 197.24 174.362 197.087 173.323L198.087 173.177C198.246 174.263 198.328 175.375 198.328 176.481C198.328 181.779 196.452 186.925 193.048 190.973C192.28 191.886 191.433 192.745 190.531 193.526C190.263 193.756 189.997 193.976 189.739 194.178C189.445 194.41 189.133 194.644 188.814 194.872C185.785 197.018 182.242 198.389 178.567 198.839C177.905 198.922 177.223 198.974 176.541 198.996C176.304 199.004 176.062 199.008 175.801 199.008Z",
    fill: "#B5DEFF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M191.517 188.408C191.441 188.308 191.368 188.227 191.297 188.162C191.276 188.133 191.24 188.102 191.183 188.069C191.175 188.063 191.169 188.061 191.162 188.056L191.16 188.058C186.961 185.736 179.383 183.844 179.383 183.844C179.164 183.339 179.181 181.586 179.213 180.538C179.999 179.626 180.711 178.198 181.111 175.972C181.238 176.067 181.335 175.85 181.335 175.85C181.264 175.725 182.398 172.958 182.194 172.334C182.079 171.981 181.843 172.022 181.66 172.124C181.687 171.964 181.714 171.797 181.743 171.62C181.743 171.62 182.192 167.379 180.045 165.015C179.824 164.802 179.032 164.749 179.032 164.749C175.584 163.693 173.516 164.164 172.22 164.719C170.301 166.292 170.155 168.969 170.242 170.444C170.281 170.793 170.321 171.144 170.359 171.486C170.36 171.492 170.361 171.497 170.361 171.497C170.377 171.63 170.393 171.764 170.41 171.894C170.23 171.784 169.995 171.731 169.865 172.081C169.635 172.695 170.474 175.459 170.578 175.629C170.578 175.629 170.758 175.913 170.9 175.784C171.297 178.211 172.012 179.704 172.762 180.626C172.687 181.988 172.444 183.691 172.377 184.141C172.377 184.141 172.376 184.141 172.376 184.142C170.615 184.697 161.786 187.046 159.114 188.802C158.872 188.951 158.624 189.349 158.375 189.944C158.814 190.513 159.28 191.058 159.773 191.58C159.904 191.72 160.038 191.858 160.173 191.995C160.869 192.696 161.611 193.351 162.397 193.952C165 195.953 168.062 197.384 171.399 198.061C172.149 198.214 172.914 198.328 173.689 198.402C174.384 198.468 175.089 198.502 175.801 198.502C176.044 198.502 176.285 198.499 176.525 198.489C177.193 198.469 177.855 198.417 178.506 198.336C182.206 197.883 185.623 196.514 188.522 194.46C188.829 194.24 189.132 194.013 189.429 193.779C189.691 193.573 189.949 193.36 190.201 193.142C191.086 192.376 191.909 191.542 192.662 190.647C192.246 189.634 191.858 188.854 191.517 188.408Z",
    fill: "#B5DEFF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M181.114 214.189C181.111 214.189 181.107 214.188 181.102 214.189C181.154 214.212 181.162 214.214 181.114 214.189Z",
    fill: "#323657"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M157.356 209.889H194.246C195.273 209.889 196.105 209.056 196.105 208.028V206.895C196.105 205.868 195.273 205.035 194.246 205.035H157.356C156.329 205.035 155.496 205.868 155.496 206.895V208.028C155.496 209.056 156.329 209.889 157.356 209.889Z",
    fill: "#B5DEFF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M157.356 218.641H194.246C195.273 218.641 196.105 217.807 196.105 216.78V215.647C196.105 214.62 195.273 213.788 194.246 213.788H157.356C156.329 213.788 155.496 214.62 155.496 215.647V216.78C155.496 217.807 156.329 218.641 157.356 218.641Z",
    fill: "#B5DEFF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M157.356 227.395H194.246C195.273 227.395 196.105 226.562 196.105 225.535V224.401C196.105 223.375 195.273 222.542 194.246 222.542H157.356C156.329 222.542 155.496 223.375 155.496 224.401V225.535C155.496 226.562 156.329 227.395 157.356 227.395Z",
    fill: "#B5DEFF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M219.405 186.322H210.594C208.68 186.322 207.129 184.771 207.129 182.858V155.621C207.129 153.707 208.68 152.156 210.594 152.156H219.405C221.318 152.156 222.87 153.707 222.87 155.621V182.858C222.87 184.771 221.318 186.322 219.405 186.322Z",
    fill: "#B5DEFF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M521.537 170H501.385C497.008 170 493.461 166.868 493.461 163.003V107.997C493.461 104.132 497.008 101 501.385 101H521.537C525.912 101 529.461 104.132 529.461 107.997V163.003C529.461 166.868 525.912 170 521.537 170Z",
    fill: "#B5DEFF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M124.67 247.479C124.67 247.479 125.275 248.469 125.35 249.279C125.41 249.919 125.949 250.876 126.182 251.404C126.415 251.932 127.165 254.324 127.192 254.947C127.203 255.201 126.635 256.805 126.715 257.318C126.796 257.831 127.089 258.847 126.629 258.915C126.168 258.983 125.646 258.149 125.646 258.149C125.646 258.149 125.689 258.622 125.3 258.802C124.542 259.153 124.14 258.843 124.14 258.843C124.14 258.843 123.861 259.364 123.51 259.434C122.736 259.588 122.357 259.277 122.357 259.277C122.357 259.277 122.016 259.568 121.481 259.558C120.797 259.545 120.51 258.954 120.51 258.954C120.51 258.954 119.643 259.129 119.392 258.726C119.141 258.321 119.185 257.89 119.081 257.524C118.976 257.158 119.055 253.85 120.179 251.469C121.302 249.089 119.893 246.765 119.893 246.765L124.67 247.479Z",
    fill: "#EEA886"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M125.767 257.839C125.767 257.839 125.844 254.872 125.063 254.241C124.282 253.608 124.193 254.68 124.193 254.68C124.193 254.68 124.299 253.621 123.446 253.478C122.593 253.335 122.557 254.593 122.557 254.593C122.557 254.593 122.417 253.777 121.52 253.944C120.624 254.111 120.837 255.153 120.837 255.153C120.837 255.153 119.981 254.132 119.426 255.113C118.488 256.769 119.392 258.726 119.392 258.726C119.392 258.726 119.656 259.174 120.509 258.954C120.509 258.954 121.08 260.104 122.356 259.278C122.356 259.278 123.663 259.997 124.14 258.844C124.14 258.844 125.581 259.528 125.767 257.839Z",
    fill: "#DB9C7C"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M134.735 204.737C134.735 204.737 129.655 221.667 127.939 227.912C127.401 229.871 126.098 248.574 125.868 249.327C125.638 250.08 119.195 251.111 119.195 251.111C119.195 251.111 119.976 227.714 120.049 226.438C120.122 225.161 127.158 199.031 129.204 198.1C130.737 197.401 131.546 197.979 133.478 199.414C136.189 201.426 134.735 204.737 134.735 204.737Z",
    fill: "#65CEFE"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M184.839 181.887L184.273 181.022L195.9 173.412L196.465 174.276L184.839 181.887Z",
    fill: "#4DA8F2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M197.704 177.786C197.704 177.786 197.593 178.444 197.403 178.709C197.403 178.709 197.023 179.162 196.772 179.5C196.693 179.608 196.626 179.704 196.59 179.77C196.436 180.047 196.183 180.702 195.629 181.263C195.076 181.825 192.919 183.611 192.919 183.611L191.071 182.043L189.152 181.183C189.152 181.183 190.227 176.513 190.682 175.93C190.727 175.873 190.773 175.819 190.82 175.771C191.254 175.315 191.768 175.158 192.023 174.945C192.117 174.867 193.104 174.155 193.456 174.247C193.944 174.373 194.231 174.66 194.343 174.987C194.343 174.987 195.288 175.277 195.656 175.832C195.656 175.832 196.537 176.072 196.799 176.892C196.799 176.892 197.664 177.236 197.704 177.786Z",
    fill: "#EFAA88"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M130.612 320.328C130.612 320.328 130.148 323.541 130.091 324.024C130.032 324.507 124.94 323.74 124.94 323.74L124.527 319.913C124.527 319.913 129.975 319.875 130.612 320.328Z",
    fill: "#424773"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M130.148 323.617C130.148 323.617 131.762 325.554 133.322 326.397C134.883 327.241 137.336 327.576 138.258 328.449C138.924 329.08 140.685 331.795 134.203 331.741C127.721 331.686 124.596 332.125 123.901 331.083C123.207 330.043 124.906 323.398 124.906 323.398C124.906 323.398 126.441 323.952 130.148 323.617Z",
    fill: "#292C47"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M167.103 320.328C167.103 320.328 166.641 323.541 166.583 324.024C166.525 324.507 161.432 323.74 161.432 323.74L161.02 319.913C161.02 319.913 166.467 319.875 167.103 320.328Z",
    fill: "#424773"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M166.639 323.616C166.639 323.616 168.253 325.553 169.814 326.397C171.375 327.24 177.118 327.934 178.041 328.808C178.707 329.439 179.815 331.978 170.694 331.74C164.215 331.571 161.088 332.124 160.393 331.083C159.699 330.042 161.398 323.398 161.398 323.398C161.398 323.398 162.845 323.988 166.639 323.616Z",
    fill: "#292C47"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M134.832 237.745C134.832 237.745 130.046 245.349 130.404 252.221C130.76 259.094 128.669 266.598 127.95 273.777C127.148 281.781 123.869 300.729 123.749 305.01C123.63 309.292 124.258 322.964 124.258 322.964L130.824 323.113C130.824 323.113 136.338 289.988 137.766 286.608C139.194 283.228 146.276 259.13 146.514 256.426C146.751 253.723 134.832 237.745 134.832 237.745Z",
    fill: "#292C47"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M160.022 238.776C160.022 238.776 163.628 257.613 164.104 261.819C164.58 266.026 164.898 282.175 165.135 284.804C165.373 287.434 167.359 319.129 167.992 323.113H159.599C159.599 323.113 153.156 300.016 153.156 289.085C153.156 278.157 148.178 265.327 144.965 258.116C141.752 250.905 134.397 250.735 132.422 237.356C132.422 237.356 157.348 234.532 160.022 238.776Z",
    fill: "#292C47"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M142.818 173.822C142.818 173.822 149.24 171.423 152.203 176.313C155.164 181.202 154.879 190.99 151.641 192.194C148.403 193.398 143.539 192.768 141.882 189.71C140.225 186.65 138.728 182.227 138.799 179.271C138.871 176.315 141.131 174.676 142.818 173.822Z",
    fill: "#EEA886"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M150.941 192.418C150.941 192.418 150.675 194.151 151.116 195.007C151.558 195.86 142.795 195.883 142.795 195.883C142.795 195.883 142.083 191.237 140.734 187.31C139.386 183.384 150.941 192.418 150.941 192.418Z",
    fill: "#EEA886"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M140.74 187.311C140.74 187.311 141.344 188.31 143.813 187.923C146.282 187.535 149.294 184.251 150.325 183.889C151.356 183.529 151.365 182.924 151.365 182.924L152.011 183.867L153.106 183.936C153.106 183.936 152.108 180.997 153.614 179.8C155.12 178.601 152.05 170.289 144.132 173.056C144.132 173.056 138.051 174.732 138.271 178.191C138.493 181.649 139.378 185.589 140.74 187.311Z",
    fill: "#D88A51"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M151.635 194.906C151.635 194.906 151.608 193.274 150.868 193.117C150.128 192.961 142.701 192.247 141.793 192.604V194.505C141.793 194.505 143.543 195.582 151.635 194.906Z",
    fill: "#E2D2CA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M151.199 181.665C151.06 181.084 149.585 179.427 149.02 181.202C148.455 182.977 149.874 185.364 150.665 185.16C151.456 184.955 151.549 183.135 151.199 181.665Z",
    fill: "#EEA886"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M163.919 197.375C158.828 196.704 151.636 194.903 151.636 194.903L141.793 194.501C141.793 194.501 132.76 196.49 129.203 198.097C128.865 198.25 128.864 206.156 127.938 208.229L130.887 214.452C130.887 214.452 132.591 226.778 132.944 232.26C133.107 234.776 129.43 255.857 129.43 255.857C129.43 255.857 133.369 257.017 140.087 257.758C146.805 258.498 163.588 257.49 163.694 256.697C163.8 255.903 160.444 227.154 160.295 225.665C160.067 223.379 161.083 211.237 161.083 211.237C162.633 210.034 176.252 203.713 179.966 200.419C180.96 199.537 185.157 195.451 186.35 194.041C190.574 189.046 194.037 184.761 194.458 183.838C194.936 183.312 189.868 180.556 189.409 180.403C189.006 180.269 183.296 187.667 181.098 190.048C180.118 191.109 176.045 194.073 176.045 194.073C176.045 194.073 167.105 197.558 163.919 197.375Z",
    fill: "#65CEFE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M140.989 174.4C140.989 174.4 132.799 175.041 140.738 187.311L140.989 174.4Z",
    fill: "#D88A51"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M196.464 174.275L197.136 173.25L195.898 173.412L196.464 174.275Z",
    fill: "#DFE1E8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M367.271 531.98H-1V49.0001C-1 56.3372 -0.534972 108.685 12.1141 176.395C19.1083 213.877 29.8412 256.071 46.2908 297.951C92.745 416.23 184.822 531.98 367.271 531.98Z",
    fill: "#21AAE9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M827 382C939.114 382 1030 288.651 1030 173.5C1030 58.3486 939.114 -35 827 -35C714.886 -35 624 58.3486 624 173.5C624 288.651 714.886 382 827 382Z",
    fill: "#21AAE9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M626 151C642.569 151 656 137.569 656 121C656 104.431 642.569 91 626 91C609.431 91 596 104.431 596 121C596 137.569 609.431 151 626 151Z",
    fill: "#DAEDF7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_1548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 604,
    y: 94,
    width: 44,
    height: 44
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M648 94H604V138H648V94Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.906 113.369C619.979 113.327 620.06 113.307 620.141 113.307C620.223 113.307 620.304 113.327 620.377 113.369L624.297 115.622C624.444 115.707 624.533 115.869 624.533 116.038V120.56C624.533 120.729 624.443 120.883 624.297 120.968L620.377 123.229C620.23 123.313 620.052 123.313 619.906 123.229L615.986 120.968C615.839 120.883 615.75 120.729 615.75 120.56V116.038C615.75 115.869 615.839 115.707 615.986 115.622L619.906 113.369Z",
    fill: "#83CD29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.536 117.351C643.55 117.344 643.567 117.344 643.583 117.344C643.599 117.344 643.608 117.343 643.622 117.351L644.376 117.791C644.404 117.807 644.423 117.837 644.423 117.87V118.733C644.423 118.766 644.404 118.795 644.376 118.812L643.622 119.243C643.594 119.26 643.564 119.26 643.536 119.243L642.782 118.812C642.753 118.795 642.734 118.766 642.734 118.733V117.87C642.734 117.837 642.753 117.807 642.782 117.791L643.536 117.351Z",
    fill: "#83CD29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.585 107.604C633.544 107.604 633.503 107.614 633.467 107.635C633.395 107.677 633.349 107.755 633.349 107.839V113.844C633.349 113.903 633.321 113.956 633.27 113.985C633.219 114.015 633.157 114.015 633.105 113.985L632.123 113.42C631.977 113.336 631.798 113.336 631.652 113.42L627.732 115.681C627.586 115.765 627.496 115.928 627.496 116.097V120.618C627.496 120.787 627.586 120.942 627.732 121.026L631.652 123.287C631.799 123.372 631.977 123.372 632.123 123.287L636.044 121.026C636.19 120.942 636.279 120.787 636.279 120.618V109.346C636.279 109.175 636.186 109.014 636.036 108.93L633.702 107.627C633.666 107.607 633.625 107.603 633.585 107.604ZM608.368 113.247C608.293 113.25 608.223 113.263 608.156 113.302L604.236 115.563C604.09 115.647 604 115.801 604 115.971L604.008 122.039C604.008 122.123 604.051 122.202 604.126 122.243C604.198 122.287 604.289 122.287 604.361 122.243L606.687 120.909C606.834 120.821 606.93 120.669 606.93 120.501V117.667C606.93 117.498 607.019 117.343 607.166 117.259L608.156 116.686C608.23 116.643 608.309 116.623 608.391 116.623C608.472 116.623 608.555 116.643 608.627 116.686L609.617 117.259C609.764 117.343 609.852 117.498 609.852 117.667V120.501C609.852 120.669 609.95 120.822 610.096 120.909L612.421 122.243C612.494 122.287 612.585 122.287 612.657 122.243C612.729 122.202 612.775 122.123 612.775 122.039L612.783 115.971C612.783 115.801 612.694 115.647 612.547 115.563L608.627 113.302C608.561 113.263 608.49 113.251 608.415 113.247H608.368ZM643.593 113.302C643.511 113.302 643.431 113.323 643.357 113.365L639.437 115.626C639.291 115.71 639.202 115.865 639.202 116.034V120.555C639.202 120.725 639.297 120.88 639.445 120.964L643.334 123.177C643.477 123.259 643.653 123.265 643.797 123.185L646.154 121.874C646.229 121.833 646.279 121.755 646.28 121.67C646.28 121.585 646.236 121.508 646.162 121.466L642.218 119.205C642.144 119.163 642.092 119.078 642.092 118.993V117.58C642.092 117.496 642.145 117.419 642.218 117.376L643.444 116.67C643.517 116.628 643.606 116.628 643.679 116.67L644.905 117.376C644.978 117.419 645.023 117.496 645.023 117.58V118.695C645.023 118.78 645.067 118.857 645.14 118.899C645.214 118.941 645.303 118.942 645.376 118.899L647.725 117.533C647.871 117.449 647.961 117.294 647.961 117.125V116.034C647.961 115.865 647.871 115.71 647.725 115.626L643.829 113.365C643.755 113.323 643.675 113.302 643.593 113.302ZM631.872 116.678C631.893 116.678 631.917 116.683 631.935 116.693L633.278 117.47C633.315 117.492 633.341 117.53 633.341 117.573V119.127C633.341 119.169 633.315 119.208 633.278 119.229L631.935 120.006C631.898 120.027 631.854 120.027 631.817 120.006L630.474 119.229C630.437 119.208 630.411 119.169 630.411 119.127V117.573C630.411 117.53 630.437 117.492 630.474 117.47L631.817 116.693C631.835 116.683 631.852 116.678 631.872 116.678Z",
    fill: "#404137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.647 136.829V127.217H618.169V128.729C618.231 128.662 618.288 128.591 618.339 128.516C618.775 127.613 619.695 127.042 620.699 127.054C621.89 127.018 622.858 127.458 623.426 128.516C623.788 129.173 623.987 129.907 624.007 130.657C624.026 131.406 623.866 132.15 623.54 132.825C623.01 134.01 621.702 134.599 620.301 134.383C619.865 134.346 619.445 134.201 619.08 133.96C618.715 133.719 618.416 133.391 618.211 133.006V136.828L617.647 136.829ZM618.169 130.617L618.286 131.746C618.492 133.03 619.253 133.789 620.447 133.932C621.008 134.024 621.584 133.919 622.075 133.635C622.568 133.351 622.946 132.905 623.145 132.374C623.61 131.269 623.576 130.017 623.053 128.938C622.84 128.462 622.478 128.068 622.02 127.815C621.563 127.563 621.036 127.466 620.519 127.54C620.033 127.575 619.571 127.76 619.195 128.07C618.82 128.38 618.551 128.798 618.425 129.268C618.314 129.712 618.228 130.163 618.169 130.617ZM634.668 131.923C634.589 132.6 634.266 133.225 633.76 133.682C633.254 134.139 632.599 134.397 631.917 134.408C629.727 134.518 628.699 133.066 628.536 131.391C628.422 130.481 628.57 129.558 628.963 128.729C629.235 128.16 629.683 127.693 630.239 127.395C630.796 127.097 631.433 126.983 632.059 127.071C632.653 127.122 633.217 127.358 633.67 127.745C634.123 128.133 634.442 128.654 634.583 129.233C634.694 129.76 634.776 130.294 634.828 130.83H629.077C628.971 132.349 629.788 133.57 630.947 133.865C632.39 134.219 633.624 133.595 634.071 132.225C634.171 131.873 634.352 131.824 634.672 131.923H634.668ZM629.073 130.344H634.217C634.185 128.726 633.175 127.55 631.806 127.536C630.261 127.511 629.14 128.64 629.073 130.344ZM635.731 131.959H636.236C636.254 132.33 636.375 132.688 636.584 132.995C636.794 133.302 637.084 133.545 637.423 133.698C637.848 133.889 638.312 133.982 638.778 133.97C639.245 133.958 639.703 133.841 640.118 133.627C640.344 133.525 640.533 133.357 640.66 133.144C640.788 132.932 640.846 132.685 640.829 132.438C640.842 132.2 640.776 131.964 640.643 131.766C640.51 131.568 640.315 131.419 640.089 131.341C639.534 131.135 638.945 131.022 638.379 130.841C637.791 130.674 637.216 130.464 636.659 130.213C635.748 129.769 635.692 128.04 636.723 127.493C637.251 127.196 637.845 127.035 638.451 127.026C639.057 127.017 639.656 127.159 640.192 127.44C640.858 127.807 641.226 128.548 641.117 129.3H640.684C640.684 129.279 640.645 129.261 640.645 129.24C640.592 127.863 639.433 127.433 638.189 127.554C637.813 127.595 637.457 127.709 637.122 127.877C636.922 127.968 636.754 128.12 636.643 128.311C636.533 128.501 636.484 128.722 636.504 128.941C636.505 129.161 636.573 129.375 636.701 129.555C636.828 129.734 637.008 129.869 637.215 129.942C637.758 130.141 638.335 130.269 638.897 130.425L640.254 130.779C640.563 130.881 640.833 131.073 641.03 131.331C641.227 131.589 641.341 131.9 641.356 132.224C641.465 132.952 641.093 133.667 640.435 133.999C639.248 134.669 637.293 134.492 636.422 133.644C635.976 133.197 635.728 132.589 635.733 131.958L635.731 131.959ZM647.754 129.3H647.281C647.281 129.237 647.256 129.175 647.249 129.127C647.241 128.773 647.112 128.432 646.883 128.162C646.654 127.892 646.338 127.709 645.99 127.643C645.333 127.455 644.632 127.488 643.996 127.739C643.744 127.811 643.523 127.962 643.365 128.17C643.206 128.378 643.12 128.631 643.118 128.893C643.109 129.149 643.189 129.401 643.344 129.605C643.5 129.809 643.721 129.954 643.971 130.014L646.132 130.568C646.366 130.624 646.596 130.694 646.821 130.777C647.511 131.028 647.978 131.667 647.999 132.397C648.01 132.754 647.911 133.107 647.718 133.407C647.524 133.708 647.243 133.943 646.913 134.082C646.412 134.309 645.868 134.43 645.317 134.435C644.766 134.441 644.22 134.331 643.714 134.114C643.298 133.935 642.946 133.633 642.707 133.248C642.468 132.863 642.353 132.415 642.377 131.963H642.839C643.013 132.799 643.588 133.496 644.377 133.825C645.166 134.155 646.067 134.074 646.785 133.61C647 133.498 647.179 133.327 647.3 133.117C647.421 132.907 647.479 132.667 647.467 132.425C647.478 132.186 647.411 131.951 647.275 131.754C647.14 131.558 646.944 131.41 646.717 131.335C646.163 131.129 645.573 131.019 645.007 130.834C644.416 130.67 643.838 130.462 643.276 130.213C642.388 129.777 642.317 128.063 643.33 127.516C643.864 127.206 644.47 127.039 645.088 127.033C645.706 127.026 646.315 127.179 646.856 127.477C647.166 127.661 647.415 127.931 647.573 128.255C647.732 128.578 647.793 128.94 647.749 129.298L647.754 129.3ZM616.787 134.234C616.601 134.305 616.396 134.305 616.21 134.234C616.024 134.163 615.87 134.027 615.778 133.851L613.94 131.313L613.673 130.959L611.54 133.855C611.453 134.023 611.308 134.154 611.131 134.224C610.955 134.293 610.759 134.296 610.58 134.231L613.328 130.55L610.772 127.225C611.151 127.088 611.574 127.236 611.785 127.579L613.69 130.148L615.606 127.589C615.693 127.424 615.839 127.296 616.014 127.231C616.19 127.165 616.384 127.166 616.559 127.234L615.566 128.548L614.223 130.295C614.185 130.328 614.155 130.369 614.135 130.414C614.115 130.46 614.104 130.509 614.104 130.559C614.104 130.609 614.115 130.658 614.135 130.704C614.155 130.75 614.185 130.79 614.223 130.824L616.782 134.234H616.787ZM628.455 127.189V127.69C628.095 127.666 627.735 127.718 627.396 127.842C627.058 127.966 626.75 128.16 626.491 128.411C626.233 128.661 626.029 128.963 625.895 129.297C625.76 129.63 625.697 129.989 625.71 130.348C625.71 131.517 625.71 132.686 625.71 133.855V134.252H625.202V127.221H625.703V128.662C626.318 127.61 627.267 127.221 628.458 127.192L628.455 127.189ZM604.001 130.505L604.225 129.401C604.84 127.218 607.346 126.309 609.07 127.661C610.08 128.453 610.332 129.574 610.283 130.838H604.594C604.503 133.095 606.134 134.458 608.22 133.763C608.908 133.512 609.425 132.942 609.596 132.233C609.706 131.878 609.888 131.818 610.222 131.92C610.166 132.352 610.013 132.766 609.774 133.131C609.535 133.495 609.217 133.801 608.842 134.025C608.224 134.363 607.514 134.497 606.815 134.407C606.116 134.318 605.463 134.01 604.949 133.528C604.442 132.958 604.135 132.237 604.075 131.476C604.075 131.351 604.033 131.234 604.004 131.122C604.001 130.911 604.001 130.706 604.001 130.505ZM604.602 130.352H609.745C609.713 128.716 608.679 127.555 607.3 127.544C605.764 127.523 604.665 128.659 604.598 130.345L604.602 130.352Z",
    fill: "black"
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M669 73C685.569 73 699 59.5685 699 43C699 26.4315 685.569 13 669 13C652.431 13 639 26.4315 639 43C639 59.5685 652.431 73 669 73Z",
    fill: "#DAEDF7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M644 50.6827H645.668V44.1352L648.25 49.8452C648.555 50.5335 648.972 50.7808 649.79 50.7808C650.608 50.7808 651.009 50.5362 651.314 49.8452L653.896 44.1352V50.6852H655.565V44.146C655.565 43.508 655.308 43.1995 654.778 43.0402C653.511 42.6469 652.661 42.9871 652.277 43.8377L649.743 49.473L647.288 43.8353C646.919 42.9847 646.053 42.6444 644.786 43.0378C644.257 43.1973 644 43.5058 644 44.1435V50.6827ZM656.951 45.3515H658.619V48.9604C658.603 49.1566 658.682 49.6168 659.596 49.6308C660.062 49.6382 663.194 49.6308 663.223 49.6308V45.3336H664.894C664.901 45.3336 664.892 51.1928 664.893 51.2179C664.902 52.6629 663.089 52.9768 662.254 53.0012H656.987V51.8851L662.264 51.8848C663.337 51.7717 663.21 51.2415 663.21 51.0628V50.6277H659.665C658.016 50.6129 656.966 49.8968 656.952 49.0733C656.951 48.9995 656.988 45.387 656.952 45.3513L656.951 45.3515Z",
    fill: "#00618A"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M666.18 50.6814H670.975C671.537 50.6814 672.082 50.5647 672.516 50.3624C673.237 50.0329 673.59 49.5862 673.59 49.0014V47.7895C673.59 47.3109 673.189 46.8644 672.404 46.5667C671.987 46.4069 671.473 46.322 670.976 46.322H668.955C668.282 46.322 667.961 46.12 667.881 45.6736C667.865 45.6205 667.865 45.5752 667.865 45.5246V44.7699C667.865 44.7274 667.865 44.6845 667.881 44.6314C667.961 44.2913 668.137 44.1953 668.731 44.1398C668.779 44.1398 668.843 44.129 668.891 44.129H673.655V43.0234H668.971C668.298 43.0234 667.945 43.066 667.624 43.1616C666.629 43.4702 666.196 43.9618 666.196 44.8124V45.78C666.196 46.5244 667.046 47.1623 668.473 47.3111C668.634 47.3217 668.794 47.3322 668.954 47.3322H670.686C670.751 47.3322 670.815 47.3322 670.863 47.343C671.392 47.3856 671.617 47.4812 671.777 47.6725C671.876 47.7708 671.906 47.8642 671.906 47.9675V48.9351C671.906 49.0521 671.826 49.201 671.665 49.3284C671.521 49.4562 671.28 49.541 670.959 49.5624C670.895 49.5624 670.847 49.573 670.783 49.573H666.18V50.6788V50.6814ZM683.996 48.757C683.996 49.8948 684.846 50.5328 686.562 50.6603C686.722 50.6726 686.882 50.6797 687.043 50.6814H691.39V49.5757H687.011C686.032 49.5757 685.663 49.3311 685.663 48.7462V43.0257H683.995V48.7566L683.996 48.757ZM674.654 48.8146V44.8726C674.654 43.8711 675.361 43.2637 676.76 43.0719C676.909 43.0507 677.059 43.0401 677.21 43.0399H680.376C680.532 43.0401 680.688 43.0507 680.842 43.0719C682.241 43.2637 682.948 43.8709 682.948 44.8726V48.8146C682.948 49.6271 682.647 50.062 681.955 50.3454L683.598 51.8204H681.661L680.332 50.6271L678.994 50.7115H677.21C676.904 50.7115 676.583 50.6687 676.229 50.5728C675.166 50.2851 674.655 49.7311 674.655 48.8146H674.654ZM676.455 48.7163C676.455 48.7696 676.471 48.8227 676.487 48.8868C676.586 49.3451 677.017 49.6007 677.674 49.6007H679.189L677.797 48.3512H679.734L680.945 49.441C681.169 49.3225 681.316 49.1411 681.366 48.9083C681.382 48.8552 681.382 48.8018 681.382 48.7485V44.9688C681.382 44.9262 681.382 44.8704 681.366 44.8195C681.267 44.3935 680.835 44.1484 680.192 44.1484H677.677C676.935 44.1484 676.455 44.468 676.455 44.9688V48.7192V48.7163Z",
    fill: "#E48E00"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M692.857 41.1912C691.831 41.1637 691.048 41.2584 690.378 41.5391C690.188 41.619 689.885 41.621 689.854 41.8582C689.958 41.9671 689.975 42.1298 690.058 42.2639C690.218 42.5213 690.488 42.8661 690.728 43.0466C690.991 43.244 691.262 43.4554 691.545 43.6267C692.047 43.931 692.607 44.1049 693.09 44.4094C693.375 44.5889 693.658 44.8151 693.935 45.0182C694.073 45.1185 694.165 45.2743 694.343 45.337V45.308C694.249 45.1892 694.226 45.026 694.139 44.9023L693.76 44.5255C693.39 44.0338 692.919 43.6068 692.419 43.2497C692.02 42.965 691.128 42.5804 690.961 42.1188L690.932 42.0898C691.215 42.0578 691.546 41.9563 691.807 41.887C692.246 41.7702 692.638 41.8002 693.09 41.6841L693.703 41.5101V41.3941C693.474 41.1605 693.311 40.8515 693.061 40.6403C692.409 40.0872 691.696 39.5353 690.962 39.0744C690.555 38.8187 690.053 38.653 689.621 38.4364C689.476 38.3636 689.221 38.3258 689.126 38.2044C688.899 37.9173 688.776 37.5529 688.601 37.221C688.235 36.5204 687.876 35.7548 687.551 35.0176C687.33 34.5149 687.185 34.019 686.91 33.5679C685.586 31.4036 684.161 30.0972 681.954 28.8135C681.484 28.5406 680.918 28.4324 680.321 28.2916L679.358 28.2335C679.163 28.1525 678.959 27.914 678.775 27.7985C678.044 27.3387 676.168 26.3399 675.626 27.651C675.284 28.4801 676.137 29.2892 676.443 29.7096C676.657 30.0045 676.931 30.3347 677.084 30.6664C677.185 30.8841 677.202 31.1027 677.288 31.3333C677.5 31.8987 677.685 32.519 677.959 33.0438C678.097 33.3093 678.25 33.5891 678.425 33.8266C678.533 33.9724 678.717 34.0365 678.746 34.2617C678.566 34.5124 678.556 34.9008 678.454 35.2185C677.999 36.6472 678.17 38.4229 678.833 39.4805C679.037 39.805 679.515 40.5012 680.174 40.2342C680.75 40.0007 680.619 39.2779 680.787 38.6397C680.824 38.4947 680.801 38.389 680.874 38.2919V38.3209L681.399 39.3645C681.787 39.9864 682.477 40.6366 683.061 41.0755C683.364 41.3029 683.605 41.6962 683.994 41.8292V41.8002H683.965C683.889 41.6822 683.77 41.6338 683.673 41.5396C683.445 41.3171 683.191 41.0406 683.002 40.7858C682.471 40.0685 682.002 39.2838 681.574 38.4664C681.37 38.0763 681.192 37.6458 681.02 37.2488C680.954 37.0957 680.955 36.8643 680.816 36.7849C680.627 37.076 680.35 37.311 680.204 37.6547C679.97 38.2039 679.94 38.8735 679.854 39.5682C679.803 39.5864 679.825 39.5739 679.796 39.5972C679.39 39.4999 679.247 39.0842 679.096 38.7275C678.714 37.8253 678.643 36.3734 678.979 35.3355C679.066 35.067 679.459 34.2209 679.3 33.9728C679.224 33.7253 678.974 33.5795 678.833 33.3926C678.66 33.1591 678.487 32.8508 678.367 32.5809C678.054 31.8778 677.909 31.0887 677.58 30.3775C677.422 30.0377 677.157 29.694 676.938 29.3942C676.697 29.0598 676.426 28.813 676.239 28.4108C676.172 28.267 676.082 28.0371 676.18 27.8889C676.19 27.8463 676.211 27.8073 676.242 27.7764C676.273 27.7456 676.313 27.7242 676.355 27.7149C676.525 27.5853 676.996 27.7579 677.172 27.8309C677.639 28.0241 678.03 28.208 678.426 28.4688C678.616 28.5917 678.808 28.8366 679.038 28.9039H679.3C679.71 28.9979 680.17 28.9335 680.553 29.049C681.231 29.2538 681.838 29.5726 682.39 29.9187C684.071 30.9739 685.445 32.4759 686.385 34.2701C686.536 34.5584 686.601 34.834 686.734 35.1398C687.003 35.7544 687.342 36.3918 687.609 36.9951C687.876 37.5974 688.136 38.2046 688.513 38.7056C688.711 38.9687 689.477 39.1102 689.825 39.2563C690.069 39.3588 690.468 39.4657 690.7 39.6042C691.141 39.8689 691.569 40.1843 691.983 40.4744C692.19 40.6194 692.826 40.9373 692.857 41.1991V41.1912Z",
    fill: "#00618A"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M679.826 30.147C679.612 30.143 679.461 30.1701 679.301 30.205V30.234H679.33C679.432 30.4425 679.612 30.5764 679.738 30.7559L680.03 31.3646L680.059 31.3356C680.239 31.209 680.322 31.0067 680.321 30.6976C680.248 30.6219 680.238 30.527 680.175 30.4366C680.092 30.3161 679.928 30.2477 679.825 30.1465L679.826 30.147Z",
    fill: "#00618A"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M692.172 49.5445C692.172 50.2746 692.752 50.7668 693.401 50.7668C694.05 50.7668 694.63 50.2746 694.63 49.5445C694.63 48.8144 694.05 48.3223 693.401 48.3223C692.752 48.3223 692.172 48.8144 692.172 49.5445ZM694.355 49.5445C694.355 50.0987 693.929 50.5126 693.401 50.5126C692.867 50.5126 692.446 50.0987 692.446 49.5445C692.446 48.9905 692.866 48.5764 693.401 48.5764C693.928 48.5764 694.355 48.9905 694.355 49.5445ZM693.732 50.2422H694.007L693.604 49.6296C693.82 49.6067 693.984 49.5022 693.984 49.2481C693.984 48.9644 693.804 48.8473 693.456 48.8473H692.909V50.2425H693.145V49.6394H693.364L693.732 50.2422ZM693.145 49.4433V49.0425H693.417C693.558 49.0425 693.728 49.0686 693.728 49.2318C693.728 49.4273 693.574 49.4437 693.397 49.4437L693.145 49.4433Z",
    fill: "#E48E00"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M722 382C738.569 382 752 368.569 752 352C752 335.431 738.569 322 722 322C705.431 322 692 335.431 692 352C692 368.569 705.431 382 722 382Z",
    fill: "#DAEDF7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_41_1548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 704,
    y: 337,
    width: 36,
    height: 36
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M740 337H704V373H740V337Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722.263 337L705.441 342.961L708.1 365.152L722.28 373L736.534 365.046L739.191 342.855L722.263 337Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.513 344.137L722.223 338.887V371.124L735.037 363.983L737.513 344.137Z",
    fill: "#A6120D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.328 344.232L709.606 364.079L722.222 371.125V338.887L707.328 344.232Z",
    fill: "#DD1B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.433 356.05L722.224 358.031H717.788L715.703 363.283L711.824 363.356L722.224 340.059L726.433 356.05ZM726.026 355.052L722.252 347.528L719.156 354.922H722.224L726.026 355.052Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.223 340.059L722.251 347.528L725.763 354.928H722.231L722.223 358.027L727.107 358.031L729.391 363.357L733.102 363.426L722.223 340.059Z",
    fill: "#B3B3B3"
  }))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M654 323C670.569 323 684 309.569 684 293C684 276.431 670.569 263 654 263C637.431 263 624 276.431 624 293C624 309.569 637.431 323 654 323Z",
    fill: "#DAEDF7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M639.262 286.853C643.064 285.409 648.275 284.529 654.001 284.529C659.726 284.529 664.937 285.409 668.74 286.853C670.638 287.574 672.22 288.449 673.339 289.453C674.456 290.456 675.177 291.652 675.177 293C675.177 294.348 674.456 295.544 673.339 296.547C672.22 297.551 670.638 298.425 668.74 299.146C664.937 300.59 659.726 301.47 654.001 301.47C648.275 301.47 643.064 300.59 639.262 299.146C637.363 298.425 635.781 297.551 634.662 296.547C633.546 295.544 632.824 294.348 632.824 293C632.824 291.652 633.546 290.456 634.662 289.453C635.781 288.449 637.363 287.574 639.262 286.853ZM635.493 290.476C634.531 291.339 634.103 292.195 634.103 293C634.103 293.805 634.531 294.661 635.493 295.524C636.452 296.386 637.878 297.192 639.696 297.882C643.326 299.26 648.384 300.126 654.001 300.126C659.618 300.126 664.675 299.26 668.305 297.882C670.123 297.192 671.549 296.386 672.508 295.524C673.47 294.661 673.898 293.805 673.898 293C673.898 292.195 673.47 291.339 672.508 290.476C671.549 289.614 670.123 288.808 668.305 288.118C664.675 286.739 659.618 285.874 654.001 285.874C648.384 285.874 643.326 286.739 639.696 288.118C637.878 288.808 636.452 289.614 635.493 290.476Z",
    fill: "#61DAFB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M651.969 277.866C655.072 280.315 658.384 284.198 661.196 288.929C664.008 293.659 665.817 298.39 666.451 302.233C666.768 304.153 666.797 305.887 666.486 307.302C666.173 308.721 665.501 309.879 664.373 310.511C663.253 311.139 661.905 311.124 660.504 310.684C659.101 310.243 657.579 309.358 656.029 308.134C652.926 305.685 649.614 301.802 646.801 297.071C643.99 292.341 642.18 287.61 641.546 283.767C641.23 281.847 641.2 280.113 641.512 278.698C641.824 277.279 642.497 276.121 643.625 275.489C644.745 274.861 646.093 274.876 647.494 275.316C648.896 275.757 650.419 276.642 651.969 277.866ZM647.126 276.548C645.914 276.167 644.946 276.216 644.226 276.62C643.514 277.019 642.998 277.793 642.736 278.982C642.473 280.176 642.483 281.728 642.784 283.552C643.385 287.194 645.121 291.771 647.873 296.4C650.624 301.028 653.839 304.781 656.794 307.113C658.272 308.28 659.661 309.072 660.871 309.452C662.084 309.833 663.052 309.784 663.772 309.38C664.484 308.981 665 308.207 665.262 307.018C665.525 305.824 665.515 304.272 665.214 302.448C664.613 298.806 662.877 294.229 660.125 289.6C657.374 284.972 654.158 281.219 651.204 278.887C649.725 277.72 648.337 276.928 647.126 276.548Z",
    fill: "#61DAFB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M660.504 275.316C661.905 274.876 663.253 274.861 664.373 275.489C665.501 276.121 666.173 277.279 666.486 278.698C666.797 280.113 666.768 281.848 666.451 283.767C665.817 287.61 664.008 292.341 661.196 297.071C658.384 301.802 655.072 305.685 651.969 308.134C650.419 309.358 648.896 310.243 647.494 310.684C646.093 311.124 644.745 311.139 643.625 310.511C642.497 309.879 641.824 308.721 641.512 307.302C641.2 305.887 641.23 304.152 641.546 302.233C642.18 298.39 643.99 293.659 646.801 288.929C649.614 284.198 652.926 280.315 656.029 277.866C657.579 276.642 659.101 275.757 660.504 275.316ZM656.794 278.887C653.839 281.219 650.624 284.972 647.873 289.6C645.121 294.229 643.385 298.806 642.784 302.448C642.483 304.272 642.473 305.824 642.736 307.018C642.998 308.207 643.514 308.981 644.226 309.38C644.946 309.784 645.914 309.833 647.126 309.452C648.337 309.072 649.725 308.28 651.204 307.113C654.158 304.781 657.374 301.028 660.125 296.4C662.877 291.771 664.613 287.194 665.214 283.552C665.515 281.728 665.525 280.176 665.262 278.982C665 277.793 664.484 277.019 663.772 276.62C663.052 276.216 662.084 276.167 660.871 276.548C659.661 276.928 658.272 277.72 656.794 278.887Z",
    fill: "#61DAFB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M654.001 297.236C656.34 297.236 658.236 295.34 658.236 293.001C658.236 290.662 656.34 288.766 654.001 288.766C651.662 288.766 649.766 290.662 649.766 293.001C649.766 295.34 651.662 297.236 654.001 297.236Z",
    fill: "#61DAFB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M627 238C643.569 238 657 224.569 657 208C657 191.431 643.569 178 627 178C610.431 178 597 191.431 597 208C597 224.569 610.431 238 627 238Z",
    fill: "#DAEDF7"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M637.636 203.91C635.236 193.324 630.235 190.506 628.959 188.514C628.433 187.636 627.967 186.724 627.564 185.783C627.496 186.724 627.373 187.316 626.573 188.029C624.968 189.46 618.152 195.015 617.578 207.043C617.044 218.258 625.823 225.173 626.982 225.888C627.874 226.326 628.96 225.897 629.49 225.494C633.722 222.59 639.504 214.847 637.641 203.91",
    fill: "#10AA50"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M627.925 219.916C627.704 222.692 627.545 224.305 626.984 225.891C626.984 225.891 627.353 228.533 627.611 231.333H628.527C628.745 229.361 629.078 227.405 629.525 225.472C628.34 224.889 627.97 222.352 627.925 219.916Z",
    fill: "#B8C4C2"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M629.526 225.474C628.329 224.921 627.982 222.33 627.929 219.916C628.225 215.934 628.311 211.94 628.188 207.949C628.125 205.855 628.217 188.554 627.672 186.021C628.045 186.879 628.475 187.711 628.959 188.512C630.235 190.506 635.238 193.324 637.636 203.91C639.504 214.828 633.753 222.551 629.526 225.474Z",
    fill: "#12924F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M212.905 42.9996C201.362 42.9996 192.004 50.3029 192.004 59.3126C192.004 67.85 200.411 74.8507 211.116 75.5604C211.349 76.9876 211.27 79.5708 208.313 81.3242C208.313 81.3242 215.894 80.0326 217.186 75.2786C226.676 73.7365 233.807 67.1743 233.807 59.3126C233.807 50.3029 224.449 42.9996 212.905 42.9996ZM212.905 43.6519C224.071 43.6519 233.155 50.676 233.155 59.3126C233.155 66.6785 226.395 73.1234 217.082 74.6367L216.667 74.702L216.557 75.109C215.852 77.7 212.978 79.1898 210.797 79.9648C211.959 78.3288 211.94 76.5571 211.76 75.456L211.677 74.942L211.16 74.9081C206.099 74.5741 201.414 72.7841 197.967 69.8722C194.542 66.9786 192.656 63.2291 192.656 59.3126C192.656 50.676 201.74 43.6519 212.905 43.6519Z",
    fill: "#13B5FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M205.622 57.2515C204.267 57.2515 203.168 58.3526 203.168 59.7068C203.168 61.0636 204.267 62.1621 205.622 62.1621C206.978 62.1621 208.077 61.0636 208.077 59.7068C208.077 58.3526 206.978 57.2515 205.622 57.2515ZM205.622 57.9038C206.616 57.9038 207.424 58.7127 207.424 59.7068C207.424 60.7009 206.616 61.5098 205.622 61.5098C204.628 61.5098 203.82 60.7009 203.82 59.7068C203.82 58.7127 204.628 57.9038 205.622 57.9038Z",
    fill: "#13B5FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M212.903 57.2515C211.548 57.2515 210.449 58.3526 210.449 59.7068C210.449 61.0636 211.548 62.1621 212.903 62.1621C214.259 62.1621 215.358 61.0636 215.358 59.7068C215.358 58.3526 214.259 57.2515 212.903 57.2515ZM212.903 57.9038C213.897 57.9038 214.706 58.7127 214.706 59.7068C214.706 60.7009 213.897 61.5098 212.903 61.5098C211.91 61.5098 211.101 60.7009 211.101 59.7068C211.101 58.7127 211.91 57.9038 212.903 57.9038Z",
    fill: "#13B5FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M220.185 57.2515C218.829 57.2515 217.73 58.3526 217.73 59.7068C217.73 61.0636 218.829 62.1621 220.185 62.1621C221.541 62.1621 222.639 61.0636 222.639 59.7068C222.639 58.3526 221.541 57.2515 220.185 57.2515ZM220.185 57.9038C221.178 57.9038 221.987 58.7127 221.987 59.7068C221.987 60.7009 221.178 61.5098 220.185 61.5098C219.191 61.5098 218.383 60.7009 218.383 59.7068C218.383 58.7127 219.191 57.9038 220.185 57.9038Z",
    fill: "#13B5FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M524.9 39.7852L524.402 39.2868L526.614 37.0756C526.914 36.7746 527.08 36.3748 527.08 35.9498C527.08 35.5248 526.914 35.1251 526.614 34.824L522.959 31.1683C522.658 30.8698 522.259 30.7028 521.834 30.7028C521.409 30.7028 521.01 30.8698 520.709 31.1683L518.498 33.382L518 32.8836L520.211 30.6725C520.645 30.2373 521.221 29.9995 521.834 29.9995C522.447 29.9995 523.023 30.2373 523.457 30.6725L527.112 34.3282C527.545 34.7608 527.784 35.3376 527.784 35.9498C527.784 36.5621 527.545 37.1389 527.112 37.5715L524.9 39.7852Z",
    fill: "#13B5FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M499.764 52.1309L499.266 51.6325L504.979 45.92L505.477 46.4183L499.764 52.1309Z",
    fill: "#13B5FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M503.834 60.8691L503.336 60.3707L511.383 52.3232L511.881 52.8216L503.834 60.8691Z",
    fill: "#13B5FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M497.42 54.4688L496.922 53.9704L499.256 51.6353L499.754 52.1337L497.42 54.4688Z",
    fill: "#13B5FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M517.775 46.9121L517.277 46.4137L524.404 39.287L524.902 39.7854L517.775 46.9121Z",
    fill: "#13B5FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M511.377 40.5117L510.879 40.0133L518.005 32.8866L518.503 33.385L511.377 40.5117Z",
    fill: "#13B5FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M505.471 46.4199L504.973 45.9216L510.881 40.0117L511.379 40.5101L505.471 46.4199Z",
    fill: "#13B5FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M511.881 52.8223L511.383 52.3239L517.291 46.4141L517.789 46.9124L511.881 52.8223Z",
    fill: "#13B5FF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M503.324 60.8691L496.922 54.466L497.42 53.9677L503.822 60.3708L503.324 60.8691Z",
    fill: "#13B5FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M495.074 62.7285L496.933 53.9675L497.527 54.2863L495.98 61.8228L503.514 60.2745L503.833 60.869L495.074 62.7285Z",
    fill: "#13B5FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M503.833 60.869L503.334 60.3706L505.416 58.2835L499.266 52.1308L499.764 51.6324L506.412 58.2835L503.833 60.869Z",
    fill: "#13B5FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M497.42 54.4688L496.922 53.9704L499.502 51.3848L499.751 51.6327L499.504 51.8832L499.751 52.1311L497.42 54.4688Z",
    fill: "#13B5FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M524.402 39.7851L518 33.3819L518.498 32.8835L524.9 39.2867L524.402 39.7851Z",
    fill: "#13B5FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M504.973 46.4199L495 36.4446L501.407 30.0389L511.379 40.0117L510.881 40.5101L501.407 31.0331L495.996 36.4446L505.471 45.9216L504.973 46.4199Z",
    fill: "#13B5FF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M521.56 63.0001L511.383 52.8223L511.881 52.324L521.56 62.0033L526.97 56.5919L517.291 46.9125L517.789 46.4141L527.966 56.5919L521.56 63.0001Z",
    fill: "#13B5FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M519.455 59.6874L518.957 59.189L520.523 57.623L521.021 58.1214L519.455 59.6874Z",
    fill: "#13B5FF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M516.822 57.0546L516.324 56.5562L517.89 54.9902L518.388 55.4886L516.822 57.0546Z",
    fill: "#13B5FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M514.182 54.4199L513.684 53.9215L515.25 52.3555L515.748 52.8539L514.182 54.4199Z",
    fill: "#13B5FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M503.65 43.8848L503.152 43.3864L504.718 41.8204L505.217 42.3188L503.65 43.8848Z",
    fill: "#13B5FF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M501.018 41.252L500.52 40.7536L502.086 39.1876L502.584 39.686L501.018 41.252Z",
    fill: "#13B5FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M498.377 38.6151L497.879 38.1193L499.445 36.5533L499.943 37.0491L498.377 38.6151Z",
    fill: "#13B5FF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M523.557 55.5598C523.273 55.5598 522.99 55.666 522.773 55.8836C522.341 56.3162 522.341 57.017 522.773 57.4496C522.99 57.6647 523.273 57.7734 523.557 57.7734C523.84 57.7734 524.123 57.6647 524.34 57.4496C524.772 57.017 524.772 56.3162 524.34 55.8836C524.123 55.666 523.84 55.5598 523.557 55.5598ZM523.557 56.2631C523.664 56.2631 523.766 56.3061 523.841 56.382C523.999 56.5388 523.999 56.7944 523.841 56.9512C523.766 57.0271 523.664 57.0701 523.557 57.0701C523.449 57.0701 523.348 57.0271 523.272 56.9512C523.114 56.7944 523.114 56.5388 523.272 56.382C523.348 56.3061 523.449 56.2631 523.557 56.2631Z",
    fill: "#13B5FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2909 76.9917C43.8446 76.6494 41.2676 77.2403 39.1374 78.8452C34.8825 82.0586 34.0359 88.1097 37.2455 92.3675C38.8534 94.4954 41.1692 95.7708 43.6156 96.1131C46.062 96.4554 48.6389 95.8645 50.7662 94.2592C55.0211 91.0458 55.8677 84.9947 52.6581 80.7369C51.0531 78.6095 48.7373 77.334 46.2909 76.9917ZM46.1889 77.7208C48.5449 78.0504 50.6354 79.2795 52.0698 81.1809C53.5043 83.0823 54.1123 85.43 53.7822 87.7892C53.4525 90.1455 52.2236 92.2362 50.3223 93.6709C48.4211 95.1056 46.0736 95.7137 43.7176 95.3841C41.3587 95.054 39.2683 93.825 37.8338 91.9235C36.3993 90.0221 35.7913 87.6744 36.121 85.3181C36.4511 82.959 37.6801 80.8682 39.5813 79.4335C41.4825 77.9989 43.83 77.3907 46.1889 77.7208Z",
    fill: "#13B5FF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1161 97.2766L50.1755 94.7008L51.3488 93.8154L53.2898 96.3883L52.1161 97.2766Z",
    fill: "#13B5FF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0307 95.0927L50.6765 97.6264L58.0319 107.376C58.3805 107.838 58.8856 108.117 59.4163 108.191C59.9499 108.266 60.512 108.136 60.974 107.788C61.9014 107.088 62.0858 105.77 61.3857 104.845L54.0307 95.0927ZM53.8863 96.1251L60.7978 105.286C61.0185 105.579 61.1107 105.94 61.0605 106.298C61.0099 106.66 60.8222 106.982 60.5301 107.199C60.2405 107.421 59.8798 107.513 59.5183 107.462C59.1567 107.412 58.838 107.224 58.6174 106.932L51.7058 97.7704L53.8863 96.1251Z",
    fill: "#13B5FF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M402.092 461C397.365 461 393.473 464.541 392.907 469.115C391.828 468.475 390.574 468.099 389.228 468.099C385.236 468.099 382 471.333 382 475.325C382 483.045 389.228 483.045 389.228 483.045H412.501C416.631 483.045 419.976 479.699 419.976 475.572C419.976 471.445 416.631 468.099 412.501 468.099C412.032 468.099 411.572 468.148 411.126 468.231C410.2 464.091 406.511 461 402.092 461ZM402.092 461.629C406.093 461.629 409.638 464.464 410.509 468.369L410.644 468.964L411.241 468.852C411.679 468.771 412.093 468.729 412.501 468.729C416.274 468.729 419.346 471.799 419.346 475.572C419.346 479.346 416.274 482.415 412.501 482.415H389.228C388.958 482.412 382.633 482.306 382.633 475.325C382.633 471.69 385.59 468.729 389.228 468.729C390.401 468.729 391.564 469.051 392.586 469.658L393.412 470.15L393.531 469.192C394.067 464.882 397.747 461.629 402.092 461.629Z",
    fill: "#13B5FF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M401.175 478.154C397.594 478.154 396.231 475.716 396.172 475.613L396.728 475.313C396.778 475.401 397.981 477.523 401.175 477.523C404.31 477.523 404.938 475.879 404.963 475.81L405.56 476.016C405.529 476.104 404.791 478.154 401.175 478.154Z",
    fill: "#13B5FF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M405.965 471.798C404.633 471.798 403.555 472.879 403.555 474.208C403.555 475.541 404.633 476.619 405.965 476.619C407.294 476.619 408.375 475.541 408.375 474.208C408.375 472.879 407.294 471.798 405.965 471.798ZM405.965 472.43C406.946 472.43 407.744 473.228 407.744 474.208C407.744 475.192 406.946 475.987 405.965 475.987C404.985 475.987 404.186 475.192 404.186 474.208C404.186 473.228 404.985 472.43 405.965 472.43Z",
    fill: "#13B5FF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M360.502 16.0029C350.283 16.0029 342 24.2869 342 34.5063C342 44.7253 350.283 53.0098 360.502 53.0098C370.717 53.0098 379 44.7253 379 34.5063C379 24.2869 370.717 16.0029 360.502 16.0029ZM360.502 16.6576C370.341 16.6576 378.346 24.6645 378.346 34.5063C378.346 44.3481 370.341 52.3551 360.502 52.3551C350.659 52.3551 342.654 44.3481 342.654 34.5063C342.654 24.6645 350.659 16.6576 360.502 16.6576Z",
    fill: "#13B5FF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M360.832 35.0294H360.176V25.6226H360.832V35.0294Z",
    fill: "#13B5FF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M360.832 53.0117H360.176V44.7391H360.832V53.0117Z",
    fill: "#13B5FF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M360.832 25.6211H360.176V16.0037H360.832V25.6211Z",
    fill: "#13B5FF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M360.832 44.7362H360.176V35.0262H360.832V44.7362Z",
    fill: "#13B5FF"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M351.107 25.6211H350.453V19.2106H351.107V25.6211Z",
    fill: "#13B5FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M351.107 35.0293H350.453V25.6226H351.107V35.0293Z",
    fill: "#13B5FF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M351.107 49.8027H350.453V44.738H351.107V49.8027Z",
    fill: "#13B5FF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M351.107 44.7402H350.453V35.0302H351.107V44.7402Z",
    fill: "#13B5FF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M370.231 35.0293H369.578V25.6224H370.231V35.0293Z",
    fill: "#13B5FF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M370.231 44.7363H369.578V35.0265H370.231V44.7363Z",
    fill: "#13B5FF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M370.231 49.8027H369.578V44.7375H370.231V49.8027Z",
    fill: "#13B5FF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M370.231 25.6211H369.578V19.0287H370.231V25.6211Z",
    fill: "#13B5FF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M378.978 35.3555H369.895V34.7008H378.978V35.3555Z",
    fill: "#13B5FF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M369.903 35.3554H360.5V34.7004H369.903V35.3554Z",
    fill: "#13B5FF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M350.785 35.3555H342.008V34.7004H350.785V35.3555Z",
    fill: "#13B5FF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M360.502 35.3555H350.793V34.7003H360.502V35.3555Z",
    fill: "#13B5FF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M360.502 45.0625H350.793V44.4073H360.502V45.0625Z",
    fill: "#13B5FF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M350.79 45.0625H345.539V44.4073H350.79V45.0625Z",
    fill: "#13B5FF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M369.903 45.0664H360.5V44.4114H369.903V45.0664Z",
    fill: "#13B5FF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M375.36 45.0625H369.895V44.4077H375.36V45.0625Z",
    fill: "#13B5FF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M350.784 25.9473H344.535V25.2921H350.784V25.9473Z",
    fill: "#13B5FF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M376.358 25.9472H369.895V25.2922H376.358V25.9472Z",
    fill: "#13B5FF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M369.903 25.9472H360.5V25.2922H369.903V25.9472Z",
    fill: "#13B5FF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M360.502 25.9473H350.793V25.2925H360.502V25.9473Z",
    fill: "#13B5FF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4365 257.281C83.5103 256.981 83.2696 256.667 82.9314 256.696L61.1273 258.58C60.6623 258.621 60.3247 258.952 60.2263 259.352C60.1656 259.599 60.1956 259.871 60.3442 260.12L63.0996 264.67L51.7762 271.518C50.8163 272.1 50.1598 273.035 49.9084 274.057C49.6848 274.966 49.7813 275.947 50.2696 276.816C51.3487 278.721 53.7817 279.35 55.644 278.224L67.105 271.291L69.8582 275.842C70.2492 276.488 71.1785 276.498 71.5836 275.865L83.3747 257.425C83.4035 257.379 83.425 257.328 83.4365 257.281ZM82.8859 257.222L71.1454 275.582C71.0124 275.791 70.8059 275.813 70.7222 275.812C70.6386 275.812 70.4325 275.787 70.3042 275.574L67.5495 271.02L67.281 270.576L66.8354 270.844L55.3736 277.78C54.5932 278.251 53.6754 278.383 52.7915 278.152C51.9084 277.918 51.1745 277.356 50.7243 276.557C50.321 275.844 50.211 274.999 50.4123 274.181C50.6376 273.265 51.2338 272.458 52.0462 271.965L63.3678 265.114L63.8135 264.846L63.5431 264.402L60.7906 259.849C60.7003 259.704 60.7098 259.567 60.7321 259.476C60.7713 259.317 60.9096 259.122 61.1711 259.101L82.8859 257.222Z",
    fill: "#13B5FF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M323 538H320V424H323V538Z",
    fill: "#706865"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M253.643 419.616L214.93 419.91L214.902 416.364L253.616 416.071L253.643 419.616Z",
    fill: "#323657"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M264.975 382.593L253.653 419.615L250.262 418.579L261.584 381.558L264.975 382.593Z",
    fill: "#323657"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M206.852 424.24H339.623V418.949H206.852V424.24Z",
    fill: "#B59074"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M223.84 517.311H226.861V424.241H223.84V517.311Z",
    fill: "#706865"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M166.784 502.037H163.152V456.201H166.784V502.037Z",
    fill: "#E1DFDD"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M210.547 496.631C210.547 496.631 210.584 498.657 211.24 501.016C211.722 502.746 212.691 509.446 213.928 510.384C215.163 511.32 219.151 513.803 218.565 516.354C217.98 518.906 217.485 520.685 213.179 519.175C208.874 517.663 205.994 516.8 205.167 513.02C204.34 509.242 201.984 505.801 201.984 505.801L198.872 513.542L197.23 512.881C197.23 512.881 199.712 504.52 199.498 503.774C199.285 503.029 200.637 496.386 205.845 494.74C211.052 493.096 210.547 496.631 210.547 496.631Z",
    fill: "#1D3B54"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M239.311 499.073C239.311 499.073 240.1 500.938 241.59 502.882C242.682 504.307 246.08 510.162 247.577 510.57C249.074 510.978 253.7 511.795 254.108 514.38C254.517 516.965 254.72 518.802 250.162 519.007C245.603 519.21 242.61 519.482 240.433 516.285C238.256 513.086 234.787 510.774 234.787 510.774V519.117H233.018C233.018 519.117 232.202 510.435 231.725 509.822C231.249 509.209 230.024 502.543 234.243 499.073C238.461 495.602 239.311 499.073 239.311 499.073Z",
    fill: "#1D3B54"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M192.965 385.702C192.965 385.702 193.978 382.109 194.077 381.64C194.175 381.173 195.134 380.242 196.328 379.27C197.522 378.297 199.57 377.518 199.824 377.597C200.077 377.676 200.37 377.638 200.788 378.176C201.207 378.713 201.264 379.398 201.264 379.398C201.264 379.398 202.091 379.819 202.098 380.669C202.098 380.669 202.859 381.1 202.709 382.066C202.709 382.066 203.44 382.508 203.272 383.2C203.272 383.2 202.313 384.135 202.057 384.582C201.802 385.031 199.673 386.837 197.365 388.254C197.365 388.254 194.419 390.43 192.965 385.702Z",
    fill: "#EEA886"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M197.371 382.854C197.371 382.854 197.808 384.366 197.716 384.854C197.623 385.34 201.17 385.41 201.17 385.41C201.17 385.41 199.223 382.373 197.371 382.854Z",
    fill: "#CF8C6C"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M157.447 391.882C158.879 389.563 160.789 388.518 166.856 392.715C172.923 396.91 171.498 396.089 172.95 397.419C174.403 398.748 180.768 402.076 180.768 402.076C180.768 402.076 184.487 398.38 186.27 395.753C188.28 392.793 192.476 384.887 192.476 384.887L198.359 389.266C198.359 389.266 186.929 409.988 184.542 411.52C182.156 413.051 174.963 410.489 171.218 408.912C167.474 407.334 163.51 405.291 161.799 404.868C160.089 404.444 153.713 397.929 157.447 391.882Z",
    fill: "#1D3B54"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M198.781 381.023L197.684 380.782L200.545 367.798L201.643 368.04L198.781 381.023Z",
    fill: "#EB4747"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 377.839C199.5 377.839 196.534 380.379 196.884 380.907C197.233 381.434 197.682 381.416 197.682 381.416L196.936 383.015C196.936 383.015 197.039 384.352 198.466 383.849C198.466 383.849 198.433 385.109 199.752 384.459C199.752 384.459 200.101 385.299 200.766 385.106C201.43 384.913 203.271 383.2 203.271 383.2C203.271 383.2 203.496 382.665 202.708 382.066C202.708 382.066 202.906 381.149 202.096 380.669C202.096 380.669 202.141 379.909 201.262 379.398C201.262 379.398 201.228 377.699 199.822 377.597C199.822 377.597 199.624 377.732 199.5 377.839Z",
    fill: "#DB9C7C"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M194.117 381.681C194.117 381.681 196.103 379.884 197.619 379.378C197.962 379.264 198.315 379.216 198.55 379.492C198.785 379.768 198.686 380.458 197.865 381.28C197.044 382.102 196.36 383.541 196.36 383.541C196.36 383.541 195.268 384.139 194.117 381.681Z",
    fill: "#EEA886"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M185.73 404.465C185.73 404.465 186.924 400.136 185.517 396.784C185.517 396.784 186.053 400.253 184.533 402.72C183.432 404.508 185.73 404.465 185.73 404.465Z",
    fill: "#152C3D"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M207.402 405.139C207.402 405.139 210.604 381.408 216.188 371.061H207.977C207.977 371.061 198.78 387.267 200.505 403.634L207.402 405.139Z",
    fill: "#EDDAD3"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M209.367 387.369C209.367 387.369 210.304 385.623 210.53 385.053C210.756 384.484 211.676 385.473 211.537 386.204C211.399 386.936 209.367 387.369 209.367 387.369Z",
    fill: "#EEA886"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M216.649 391.34C216.649 391.34 216.401 392.196 216.111 392.517C216.111 392.517 215.537 393.06 215.152 393.472C215.031 393.603 214.928 393.719 214.87 393.801C214.624 394.144 214.189 394.972 213.368 395.632C212.548 396.292 209.416 398.33 209.416 398.33L207.207 395.97L205.438 394.13C205.438 394.13 206.932 388.511 207.626 387.808C207.694 387.738 207.763 387.674 207.834 387.618C208.479 387.079 209.184 386.948 209.554 386.706C209.69 386.616 211.108 385.825 211.56 386C212.188 386.242 212.525 386.666 212.622 387.116C212.622 387.116 213.831 387.646 214.234 388.437C214.234 388.437 215.365 388.89 215.587 390.017C215.587 390.017 216.682 390.606 216.649 391.34Z",
    fill: "#EEA886"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M231.188 452.621C231.188 452.621 225.762 464.829 221.889 473.541C221.239 475.008 220.631 476.374 220.101 477.566C219.48 478.964 218.964 480.122 218.609 480.922C216.144 486.467 210.08 498.561 210.08 498.561C210.08 498.561 205.519 498.735 205.254 494.861C205.254 494.861 209.631 486.467 209.631 480.57C209.631 474.67 210.423 457.296 216.058 453.54C222.929 448.96 227.391 448.093 231.188 452.621Z",
    fill: "#EEA886"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M181.015 429.416C181.015 429.416 182.16 430.56 183.129 430.824C184.097 431.089 200.296 432.322 207.779 434.787C215.264 437.252 225.212 438.837 227.061 440.95C228.91 443.063 231.991 454.684 231.903 456.885C231.815 459.086 238.48 496.178 239.31 499.074C239.75 500.608 233.283 500.02 233.283 500.02C233.283 500.02 224.093 478.102 222.131 474.053C218.524 466.614 218.344 457.502 217.024 456.092C215.703 454.684 201.001 451.515 192.549 451.515C184.097 451.515 165.168 452.219 163.143 451.074C161.118 449.929 148.44 441.566 153.723 430.384C159.005 419.204 181.015 429.416 181.015 429.416Z",
    fill: "#EEA886"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M217.577 437.424L204.168 463.227C204.168 463.227 200.129 453.652 193.083 452.003C186.035 450.356 157.913 451.239 157.913 451.239C157.913 451.239 145.008 434.915 156.059 426.351C167.11 417.787 180.016 427.698 180.016 427.698C180.016 427.698 182.682 430.589 183.971 430.652C193.348 431.119 203.347 432.866 217.577 437.424Z",
    fill: "#1D3B54"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M247.579 510.57C247.579 510.57 243.497 511.591 241.932 510.57C240.368 509.55 235.047 500.558 233.285 500.02C233.285 500.02 234.993 496.555 239.312 499.073C239.312 499.073 246.422 509.073 247.579 510.57Z",
    fill: "#EEA886"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M213.932 510.385C213.932 510.385 209.764 509.808 208.693 508.277C207.622 506.748 206.04 496.42 204.605 495.263C204.605 495.263 207.483 492.685 210.551 496.632C210.551 496.632 213.417 508.563 213.932 510.385Z",
    fill: "#EEA886"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M171.344 348.385C174.565 348.229 181.708 349.849 182.808 358.383C182.808 358.383 182.551 360.684 181.993 362.493C181.434 364.3 183.054 369.63 182.631 369.893C182.209 370.155 180.461 370.492 180.461 370.492C180.461 370.492 178.583 376.315 176.538 376.265C174.494 376.215 166.755 374.618 163.11 367.373C159.466 360.129 158.34 349.014 171.344 348.385Z",
    fill: "#EEA886"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M173.773 373.611C173.773 373.611 173.521 374.427 173.236 375.639C173.089 376.258 172.934 376.979 172.799 377.747C172.429 379.871 172.211 382.355 172.762 384.008C172.762 384.008 168.242 385.574 164.671 379.186C164.671 379.186 166.204 372.304 164.211 368.13C162.219 363.959 173.773 373.611 173.773 373.611Z",
    fill: "#EEA886"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M182.805 358.382C182.805 358.382 177.864 362.817 172.637 362.466C167.33 362.109 163.884 368.742 163.884 368.742C163.884 368.742 155.984 358.827 162.353 350.812C168.722 342.793 183.934 348.434 182.805 358.382Z",
    fill: "#1D3B54"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M170.232 362.428C170.204 361.424 169.086 359.916 167.44 361.289C165.794 362.662 168.007 367.437 169.356 366.97C170.705 366.502 170.261 363.467 170.232 362.428Z",
    fill: "#EEA886"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M173.238 375.638C173.092 376.256 172.937 376.978 172.802 377.746C168.605 375.08 166.492 371.844 166.492 371.844C168.891 374.014 173.238 375.638 173.238 375.638Z",
    fill: "#A77860"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M185.487 400.05C184.535 404.459 182.032 404.69 182.184 407.947C182.336 411.204 183.309 411.483 181.624 416.619C181.312 417.569 181.059 418.605 180.855 419.661C180.831 419.785 180.806 419.912 180.785 420.037C180.675 420.63 180.581 421.228 180.5 421.816C180.35 422.906 180.243 423.971 180.167 424.943C179.969 427.477 181.835 429.434 181.835 429.434C181.835 429.434 165.356 439.307 154.043 437.921C154.043 437.921 156.972 425.61 158.585 421.38C160.198 417.152 159.711 397.61 158.524 393.418C156.772 387.229 160.272 377.951 165.055 376.742L172.472 380.176C172.472 380.176 179.942 389.098 181.618 390.445C183.293 391.793 186.453 395.579 185.487 400.05Z",
    fill: "#1D3B54"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M160.974 381.984C163.068 380.241 166.099 377.255 170.52 383.16C174.941 389.066 178.157 392.871 179.112 394.593C180.068 396.316 188.378 408.313 188.378 408.313C188.378 408.313 192.793 404.214 195.318 402.291C198.163 400.123 205.918 392.043 205.918 392.043L211.044 397.726C211.044 397.726 193.262 417.458 190.513 418.152C187.763 418.848 180.062 411.919 177.012 409.232C173.962 406.547 165.405 396.768 163.918 395.822C162.432 394.878 155.512 386.533 160.974 381.984Z",
    fill: "#1D3B54"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M221.888 473.539C221.239 475.006 220.63 476.372 220.1 477.564C218.104 471.147 218.269 460.424 218.269 460.424C219.468 467.9 221.852 473.454 221.888 473.539Z",
    fill: "#A77860"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M135.965 451.236H193.08V457.521H135.965V451.236Z",
    fill: "#B5DEFF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M165.685 431.191C165.685 431.191 164.245 437.013 171.024 438.336C177.805 439.659 186.142 441.349 186.142 451.809H162.629L165.685 431.191Z",
    fill: "#B5DEFF"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M200.547 367.797L201.518 366.008L201.645 368.039L200.547 367.797Z",
    fill: "#EEA886"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M135.967 457.521L116 373.604C116 373.604 152.098 367.963 156.399 384.173C160.699 400.385 167.775 448.535 176.376 451.512C184.977 454.489 135.967 457.521 135.967 457.521Z",
    fill: "#B5DEFF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M182.399 413.818C182.399 413.818 182.031 415.358 181.638 416.633L172.855 405.244L182.399 413.818Z",
    fill: "#152C3D"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M160.379 361.616C160.379 361.616 163.851 370.788 162.907 373.293C162.907 373.293 168.326 370.979 167.336 364.969C166.347 358.961 160.379 361.616 160.379 361.616Z",
    fill: "#1D3B54"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M172.903 380.688V378.872L165.197 375.119L162.531 378.198L172.903 380.688Z",
    fill: "#1D3B54"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M200.221 513.872C200.221 515.521 198.884 516.857 197.236 516.857C195.587 516.857 194.25 515.521 194.25 513.872C194.25 512.222 195.587 510.886 197.236 510.886C198.884 510.886 200.221 512.222 200.221 513.872Z",
    fill: "#BFB2AC"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M132.98 510.912L133.737 513.039L165.686 503.14L164.155 498.832L132.98 510.912Z",
    fill: "#E1DFDD"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M197.233 510.912L196.477 513.039L164.527 503.14L165.931 498.562L197.233 510.912Z",
    fill: "#E1DFDD"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M174.723 512.811V515.285L164.527 503.139L165.931 498.561L174.723 512.811Z",
    fill: "#E1DFDD"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M174.976 513.872C174.976 515.521 173.639 516.857 171.99 516.857C170.341 516.857 169.004 515.521 169.004 513.872C169.004 512.222 170.341 510.886 171.99 510.886C173.639 510.886 174.976 512.222 174.976 513.872Z",
    fill: "#BFB2AC"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M135.964 513.872C135.964 515.521 134.627 516.857 132.978 516.857C131.329 516.857 129.992 515.521 129.992 513.872C129.992 512.222 131.329 510.886 132.978 510.886C134.627 510.886 135.964 512.222 135.964 513.872Z",
    fill: "#BFB2AC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 305,
    y: 130,
    width: 3,
    height: 3
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M305.981 130.287H308V132.309H305.981V130.287Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 305,
    y: 130,
    width: 3,
    height: 3
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M307.23 130.387C307.127 130.363 307.022 130.355 306.915 130.362C306.809 130.37 306.706 130.393 306.607 130.432C306.509 130.47 306.42 130.523 306.339 130.588C306.257 130.654 306.19 130.73 306.135 130.817C306.12 130.85 306.1 130.878 306.084 130.908C306.057 130.959 306.038 131.012 306.027 131.068C306.011 131.128 306.002 131.188 305.998 131.25C305.995 131.311 305.998 131.372 306.008 131.433C306.017 131.494 306.032 131.554 306.054 131.611C306.077 131.67 306.104 131.726 306.138 131.778C306.171 131.831 306.21 131.88 306.254 131.926C306.297 131.972 306.345 132.013 306.398 132.05C306.45 132.087 306.506 132.118 306.565 132.145C306.623 132.171 306.685 132.192 306.748 132.207C306.85 132.23 306.953 132.238 307.058 132.231C307.162 132.224 307.263 132.202 307.36 132.165C307.457 132.128 307.546 132.078 307.627 132.015C307.707 131.952 307.776 131.879 307.832 131.796L307.906 131.657H307.909C307.929 131.614 307.945 131.569 307.955 131.522C307.971 131.463 307.98 131.403 307.983 131.341C307.986 131.28 307.982 131.219 307.972 131.158C307.962 131.097 307.946 131.038 307.924 130.98C307.902 130.922 307.874 130.867 307.841 130.814C307.807 130.761 307.768 130.712 307.724 130.667C307.68 130.621 307.632 130.58 307.58 130.544C307.528 130.507 307.472 130.476 307.413 130.449C307.355 130.423 307.294 130.402 307.23 130.387Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.077 129.981L305.598 132.16L307.904 132.611L308.382 130.432L306.077 129.981Z",
    fill: "url(#paint12_linear_41_1548)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 305,
    y: 139,
    width: 3,
    height: 3
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M305.785 139.845H307.942V141.867H305.785V139.845Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 305,
    y: 139,
    width: 3,
    height: 3
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M307.161 139.956C307.057 139.932 306.952 139.924 306.845 139.932C306.739 139.939 306.636 139.962 306.538 140.001C306.439 140.04 306.35 140.092 306.269 140.157C306.188 140.223 306.12 140.299 306.065 140.386L306.011 140.477C305.988 140.529 305.968 140.582 305.953 140.637C305.924 140.745 305.916 140.855 305.928 140.967C305.941 141.079 305.973 141.184 306.026 141.285C306.079 141.385 306.148 141.473 306.234 141.55C306.321 141.628 306.418 141.688 306.528 141.732C306.637 141.776 306.75 141.801 306.869 141.806C306.988 141.812 307.103 141.797 307.217 141.764C307.33 141.73 307.434 141.679 307.528 141.611C307.621 141.542 307.7 141.46 307.763 141.365C307.79 141.321 307.813 141.274 307.836 141.23H307.84C307.859 141.186 307.871 141.143 307.886 141.096C307.902 141.035 307.911 140.975 307.914 140.913C307.917 140.852 307.914 140.791 307.904 140.73C307.894 140.669 307.878 140.609 307.856 140.551C307.834 140.493 307.806 140.437 307.772 140.385C307.738 140.332 307.7 140.283 307.656 140.237C307.612 140.191 307.564 140.15 307.512 140.113C307.459 140.077 307.404 140.045 307.344 140.019C307.285 139.992 307.224 139.971 307.161 139.956Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.998 139.549L305.518 141.734L307.835 142.187L308.314 140.002L305.998 139.549Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 288,
    y: 126,
    width: 18,
    height: 20
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M288 126H305.197V145.853H288V126Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 288,
    y: 125,
    width: 18,
    height: 21
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M304.26 142.308C304.121 142.281 303.983 142.281 303.844 142.31C303.705 142.339 303.579 142.393 303.465 142.472C303.078 142.732 302.671 142.959 302.243 143.154C301.816 143.35 301.374 143.51 300.917 143.635C300.462 143.761 299.998 143.849 299.526 143.9C299.054 143.952 298.581 143.966 298.106 143.942L297.971 143.935C297.582 143.91 297.196 143.86 296.814 143.786C292.211 142.887 289.255 138.639 290.208 134.299C291.161 129.961 295.664 127.168 300.263 128.068C301.389 128.286 302.426 128.704 303.372 129.32H303.376C303.433 129.369 303.494 129.412 303.561 129.447C303.652 129.493 303.747 129.526 303.847 129.546C303.958 129.567 304.07 129.57 304.183 129.555C304.295 129.54 304.402 129.508 304.504 129.46C304.605 129.412 304.695 129.348 304.773 129.271C304.852 129.193 304.916 129.106 304.963 129.009C305.01 128.912 305.04 128.81 305.05 128.703C305.061 128.596 305.053 128.491 305.027 128.386C305.001 128.282 304.956 128.185 304.895 128.095C304.834 128.005 304.758 127.927 304.669 127.861H304.665L304.599 127.817L304.584 127.806C303.397 127.018 302.093 126.485 300.672 126.208C294.985 125.097 289.418 128.545 288.237 133.914C287.056 139.283 290.714 144.532 296.405 145.645C297.11 145.784 297.823 145.853 298.544 145.853C299.265 145.853 299.978 145.783 300.684 145.645C301.389 145.506 302.072 145.301 302.733 145.029C303.394 144.758 304.019 144.426 304.607 144.033L304.626 144.022L304.669 143.99L304.688 143.979C304.873 143.835 304.992 143.654 305.043 143.432C305.057 143.371 305.063 143.31 305.063 143.247C305.064 143.185 305.058 143.123 305.046 143.061C305.033 143 305.014 142.94 304.989 142.882C304.965 142.825 304.934 142.77 304.897 142.717C304.861 142.665 304.82 142.617 304.773 142.572C304.727 142.528 304.677 142.488 304.621 142.453C304.567 142.418 304.509 142.388 304.448 142.364C304.387 142.339 304.324 142.321 304.26 142.308Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.702 122.803L283.822 145.037L304.363 149.05L309.242 126.817L288.702 122.803Z",
    fill: "url(#paint13_linear_41_1548)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: 129,
    width: 13,
    height: 13
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M303.53 129.735H291.961V141.868H303.53V129.735Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 292,
    y: 129,
    width: 12,
    height: 13
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M300.179 141.59C299.653 141.729 299.116 141.802 298.569 141.81C298.023 141.817 297.484 141.758 296.953 141.634L296.73 141.576H296.726C296.609 141.545 296.492 141.509 296.377 141.471C296.263 141.433 296.149 141.392 296.037 141.348C295.924 141.304 295.813 141.257 295.703 141.206C295.593 141.156 295.485 141.103 295.379 141.047C295.272 140.991 295.168 140.931 295.065 140.87C294.962 140.808 294.862 140.744 294.762 140.676C294.663 140.609 294.567 140.539 294.472 140.467C294.378 140.394 294.285 140.32 294.195 140.242C294.105 140.164 294.018 140.085 293.932 140.002C293.847 139.92 293.764 139.836 293.684 139.749C293.604 139.662 293.527 139.573 293.452 139.482C293.377 139.392 293.305 139.298 293.236 139.204C293.167 139.109 293.102 139.013 293.038 138.914C292.975 138.816 292.915 138.715 292.858 138.614C292.801 138.512 292.747 138.409 292.696 138.305C292.646 138.2 292.598 138.094 292.554 137.987C292.509 137.88 292.468 137.772 292.431 137.663C292.393 137.553 292.359 137.443 292.327 137.332C292.297 137.22 292.269 137.108 292.244 136.996C292.221 136.883 292.2 136.769 292.182 136.656C292.165 136.542 292.151 136.428 292.141 136.313C292.13 136.199 292.123 136.084 292.12 135.969C292.117 135.854 292.117 135.739 292.121 135.624C292.124 135.509 292.132 135.394 292.143 135.279C292.153 135.165 292.167 135.051 292.185 134.937C292.202 134.823 292.223 134.71 292.248 134.597C292.272 134.485 292.3 134.373 292.331 134.261C292.362 134.151 292.397 134.04 292.435 133.931C292.473 133.822 292.515 133.713 292.559 133.606C292.604 133.499 292.651 133.394 292.702 133.289C292.754 133.185 292.807 133.081 292.865 132.98C292.922 132.879 292.983 132.779 293.046 132.681C293.109 132.582 293.176 132.486 293.245 132.391C293.314 132.297 293.386 132.204 293.462 132.114C293.536 132.022 293.614 131.934 293.694 131.847C293.774 131.761 293.858 131.676 293.943 131.594C294.028 131.513 294.116 131.433 294.206 131.355C294.296 131.278 294.389 131.203 294.484 131.131C294.579 131.059 294.676 130.989 294.774 130.922C294.874 130.856 294.975 130.791 295.078 130.729C295.181 130.668 295.285 130.609 295.392 130.553C295.499 130.497 295.607 130.445 295.716 130.395C295.827 130.344 295.938 130.298 296.05 130.254C296.163 130.209 296.277 130.169 296.392 130.131C296.507 130.093 296.623 130.058 296.74 130.027C296.858 129.995 296.976 129.967 297.095 129.942C297.214 129.917 297.333 129.895 297.454 129.877C297.574 129.858 297.695 129.842 297.816 129.831C297.937 129.819 298.059 129.809 298.18 129.804C298.302 129.799 298.424 129.796 298.546 129.798C298.668 129.799 298.789 129.803 298.911 129.811C299.033 129.819 299.154 129.829 299.275 129.844C299.396 129.858 299.516 129.876 299.636 129.897C299.756 129.918 299.875 129.941 299.993 129.969C300.112 129.996 300.23 130.026 300.346 130.06C300.463 130.094 300.579 130.13 300.693 130.17C300.807 130.21 300.92 130.253 301.032 130.299C301.143 130.346 301.253 130.395 301.362 130.446C301.471 130.499 301.578 130.553 301.684 130.611C301.789 130.669 301.892 130.73 301.994 130.793C302.096 130.856 302.195 130.922 302.293 130.991C302.391 131.06 302.486 131.131 302.58 131.205C302.673 131.279 302.764 131.356 302.853 131.435C302.941 131.514 303.027 131.595 303.111 131.678L303.277 131.854C303.299 131.879 303.318 131.907 303.335 131.937C303.399 132.043 303.442 132.157 303.464 132.277C303.484 132.398 303.483 132.518 303.458 132.638C303.434 132.758 303.388 132.87 303.321 132.974C303.253 133.079 303.168 133.169 303.067 133.244C302.965 133.32 302.853 133.377 302.729 133.414C302.606 133.452 302.48 133.468 302.35 133.462C302.221 133.457 302.097 133.43 301.977 133.383C301.858 133.335 301.751 133.27 301.657 133.186L301.557 133.08C301.384 132.906 301.195 132.748 300.992 132.606C300.789 132.464 300.574 132.34 300.347 132.235C300.121 132.129 299.886 132.043 299.643 131.978C299.4 131.912 299.152 131.867 298.901 131.844C298.649 131.82 298.397 131.818 298.145 131.836C297.893 131.856 297.645 131.895 297.401 131.957C297.156 132.018 296.92 132.099 296.691 132.2C296.462 132.302 296.244 132.422 296.038 132.559C295.832 132.697 295.641 132.852 295.464 133.023C295.287 133.194 295.128 133.377 294.987 133.576C294.846 133.773 294.724 133.98 294.622 134.199C294.52 134.417 294.44 134.643 294.381 134.874C294.322 135.106 294.285 135.341 294.271 135.58C294.257 135.818 294.265 136.055 294.296 136.292C294.327 136.529 294.381 136.761 294.456 136.988C294.532 137.216 294.628 137.436 294.745 137.647C294.862 137.859 294.999 138.058 295.153 138.246C295.309 138.435 295.481 138.608 295.669 138.768C295.857 138.926 296.06 139.069 296.275 139.193C296.491 139.318 296.716 139.423 296.952 139.51C297.187 139.596 297.429 139.662 297.677 139.708C297.925 139.754 298.176 139.778 298.429 139.781C298.681 139.784 298.933 139.765 299.182 139.726C299.431 139.686 299.675 139.626 299.913 139.545C300.439 139.367 300.909 139.1 301.321 138.744C301.325 138.744 301.325 138.744 301.325 138.74L301.413 138.664C301.462 138.625 301.513 138.59 301.568 138.558C301.679 138.497 301.798 138.455 301.924 138.434C302.051 138.413 302.178 138.413 302.304 138.435C302.431 138.456 302.55 138.498 302.66 138.56C302.771 138.621 302.867 138.699 302.948 138.793C303.029 138.888 303.091 138.992 303.132 139.107C303.173 139.222 303.193 139.34 303.19 139.461C303.186 139.583 303.16 139.7 303.112 139.813C303.064 139.925 302.997 140.027 302.911 140.116C302.874 140.159 302.833 140.196 302.787 140.229H302.783C302.031 140.881 301.164 141.335 300.179 141.59Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.861 132.411L301.012 125.371L308.741 139.203L294.59 146.242L286.861 132.411Z",
    fill: "url(#paint14_linear_41_1548)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 133,
    width: 10,
    height: 5
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M304.314 133.963H295.883V137.639H304.314V133.963Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 134,
    width: 10,
    height: 4
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M295.992 135.558C296.006 135.46 296.029 135.362 296.06 135.268C296.092 135.172 296.132 135.08 296.179 134.991C296.227 134.902 296.283 134.818 296.346 134.738C296.409 134.657 296.479 134.583 296.555 134.514C296.632 134.445 296.714 134.383 296.801 134.327C296.888 134.271 296.98 134.222 297.077 134.181C297.173 134.14 297.272 134.106 297.375 134.081C297.477 134.056 297.581 134.038 297.686 134.03C297.791 134.02 297.896 134.02 298.002 134.028C298.108 134.035 298.211 134.052 298.314 134.076C298.416 134.101 298.516 134.133 298.612 134.173C298.71 134.213 298.802 134.261 298.89 134.316C298.979 134.371 299.061 134.432 299.139 134.501C299.215 134.569 299.286 134.643 299.35 134.723C299.414 134.802 299.47 134.886 299.519 134.974C299.568 135.062 299.609 135.154 299.642 135.249C300.012 135.446 300.521 135.566 301.089 135.566C301.574 135.566 302.022 135.475 302.373 135.326C302.463 135.181 302.585 135.068 302.74 134.987C302.816 134.945 302.897 134.914 302.983 134.893C303.033 134.881 303.085 134.874 303.138 134.871C303.281 134.858 303.42 134.873 303.557 134.918C303.693 134.962 303.812 135.031 303.917 135.125H303.92L303.994 135.202C304.033 135.243 304.067 135.288 304.094 135.337C304.126 135.39 304.153 135.446 304.173 135.505C304.194 135.563 304.208 135.623 304.217 135.685C304.224 135.746 304.227 135.808 304.221 135.869C304.217 135.93 304.206 135.991 304.188 136.05C304.171 136.11 304.148 136.167 304.118 136.223C304.089 136.277 304.054 136.33 304.014 136.378C303.974 136.427 303.929 136.471 303.88 136.512C303.83 136.552 303.776 136.587 303.72 136.618C303.539 136.714 303.344 136.754 303.138 136.735C303.085 136.73 303.033 136.721 302.983 136.709C302.822 136.671 302.681 136.599 302.559 136.494L302.447 136.381C302.447 136.379 302.445 136.378 302.443 136.378L302.373 136.279C302.022 136.126 301.574 136.035 301.089 136.035C300.521 136.035 300.012 136.156 299.642 136.355C299.604 136.459 299.558 136.559 299.501 136.654C299.444 136.749 299.379 136.839 299.305 136.923C299.231 137.007 299.149 137.084 299.06 137.153C298.97 137.223 298.875 137.284 298.774 137.337C298.673 137.39 298.567 137.434 298.458 137.469C298.347 137.504 298.236 137.529 298.121 137.544C298.006 137.559 297.891 137.564 297.775 137.56C297.66 137.555 297.546 137.54 297.432 137.515C297.32 137.49 297.21 137.456 297.104 137.412C296.998 137.369 296.897 137.315 296.801 137.254C296.705 137.193 296.616 137.124 296.534 137.047C296.452 136.97 296.377 136.887 296.312 136.797C296.246 136.707 296.189 136.613 296.142 136.513C296.094 136.413 296.057 136.31 296.029 136.204C296.002 136.098 295.985 135.99 295.979 135.881C295.972 135.772 295.977 135.663 295.992 135.555V135.558Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.887 132.474L304.972 137.418L296.312 139.111L295.226 134.166L303.887 132.474Z",
    fill: "url(#paint15_linear_41_1548)"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 592,
    y: 373,
    width: 3,
    height: 3
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M592.981 373.287H595V375.309H592.981V373.287Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 592,
    y: 373,
    width: 3,
    height: 3
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M594.23 373.387C594.127 373.363 594.022 373.355 593.915 373.362C593.809 373.37 593.706 373.393 593.607 373.432C593.509 373.47 593.42 373.523 593.339 373.588C593.257 373.654 593.19 373.73 593.135 373.817C593.12 373.85 593.1 373.878 593.084 373.908C593.057 373.959 593.038 374.012 593.027 374.068C593.011 374.128 593.002 374.188 592.998 374.25C592.995 374.311 592.998 374.372 593.008 374.433C593.017 374.494 593.032 374.554 593.054 374.611C593.077 374.67 593.104 374.726 593.138 374.778C593.171 374.831 593.21 374.88 593.254 374.926C593.297 374.972 593.345 375.013 593.398 375.05C593.45 375.087 593.506 375.118 593.565 375.145C593.623 375.171 593.685 375.192 593.748 375.207C593.85 375.23 593.953 375.238 594.058 375.231C594.162 375.224 594.263 375.202 594.36 375.165C594.457 375.128 594.546 375.078 594.627 375.015C594.707 374.952 594.776 374.879 594.832 374.796L594.906 374.657H594.909C594.929 374.614 594.945 374.569 594.955 374.522C594.971 374.463 594.98 374.403 594.983 374.341C594.986 374.28 594.982 374.219 594.972 374.158C594.962 374.097 594.946 374.038 594.924 373.98C594.902 373.922 594.874 373.867 594.841 373.814C594.807 373.761 594.768 373.712 594.724 373.667C594.68 373.621 594.632 373.58 594.58 373.544C594.528 373.507 594.472 373.476 594.413 373.449C594.355 373.423 594.294 373.402 594.23 373.387Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.077 372.981L592.598 375.16L594.904 375.611L595.382 373.432L593.077 372.981Z",
    fill: "url(#paint16_linear_41_1548)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 592,
    y: 382,
    width: 3,
    height: 3
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M592.785 382.845H594.942V384.867H592.785V382.845Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 592,
    y: 382,
    width: 3,
    height: 3
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M594.161 382.956C594.057 382.932 593.952 382.924 593.845 382.932C593.739 382.939 593.636 382.962 593.538 383.001C593.439 383.04 593.35 383.092 593.269 383.157C593.188 383.223 593.12 383.299 593.065 383.386L593.011 383.477C592.988 383.529 592.968 383.582 592.953 383.637C592.924 383.745 592.916 383.855 592.928 383.967C592.941 384.079 592.973 384.184 593.026 384.285C593.079 384.385 593.148 384.473 593.234 384.55C593.321 384.628 593.418 384.688 593.528 384.732C593.637 384.776 593.75 384.801 593.869 384.806C593.988 384.812 594.103 384.797 594.217 384.764C594.33 384.73 594.434 384.679 594.528 384.611C594.621 384.542 594.7 384.46 594.763 384.365C594.79 384.321 594.813 384.274 594.836 384.23H594.84C594.859 384.186 594.871 384.143 594.886 384.096C594.902 384.035 594.911 383.975 594.914 383.913C594.917 383.852 594.914 383.791 594.904 383.73C594.894 383.669 594.878 383.609 594.856 383.551C594.834 383.493 594.806 383.437 594.772 383.385C594.738 383.332 594.7 383.283 594.656 383.237C594.612 383.191 594.564 383.15 594.512 383.113C594.459 383.077 594.404 383.045 594.344 383.019C594.285 382.992 594.224 382.971 594.161 382.956Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.998 382.549L592.518 384.734L594.835 385.187L595.314 383.002L592.998 382.549Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 575,
    y: 369,
    width: 18,
    height: 20
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M575 369H592.197V388.853H575V369Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 575,
    y: 368,
    width: 18,
    height: 21
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M591.26 385.308C591.121 385.281 590.983 385.281 590.844 385.31C590.705 385.339 590.579 385.393 590.465 385.472C590.078 385.732 589.671 385.959 589.243 386.154C588.816 386.35 588.374 386.51 587.917 386.635C587.462 386.761 586.998 386.849 586.526 386.9C586.054 386.952 585.581 386.966 585.106 386.942L584.971 386.935C584.582 386.91 584.196 386.86 583.814 386.786C579.211 385.887 576.255 381.639 577.208 377.299C578.161 372.961 582.664 370.168 587.263 371.068C588.389 371.286 589.426 371.704 590.372 372.32H590.376C590.433 372.369 590.494 372.412 590.561 372.447C590.652 372.493 590.747 372.526 590.847 372.546C590.958 372.567 591.07 372.57 591.183 372.555C591.295 372.54 591.402 372.508 591.504 372.46C591.605 372.412 591.695 372.348 591.773 372.271C591.852 372.193 591.916 372.106 591.963 372.009C592.01 371.912 592.04 371.81 592.05 371.703C592.061 371.596 592.053 371.491 592.027 371.386C592.001 371.282 591.956 371.185 591.895 371.095C591.834 371.005 591.758 370.927 591.669 370.861H591.665L591.599 370.817L591.584 370.806C590.397 370.018 589.093 369.485 587.672 369.208C581.985 368.097 576.418 371.545 575.237 376.914C574.056 382.283 577.714 387.532 583.405 388.645C584.11 388.784 584.823 388.853 585.544 388.853C586.265 388.853 586.978 388.783 587.684 388.645C588.389 388.506 589.072 388.301 589.733 388.029C590.394 387.758 591.019 387.426 591.607 387.033L591.626 387.022L591.669 386.99L591.688 386.979C591.873 386.835 591.992 386.654 592.043 386.432C592.057 386.371 592.063 386.31 592.063 386.247C592.064 386.185 592.058 386.123 592.046 386.061C592.033 386 592.014 385.94 591.989 385.882C591.965 385.825 591.934 385.77 591.897 385.717C591.861 385.665 591.82 385.617 591.773 385.572C591.727 385.528 591.677 385.488 591.621 385.453C591.567 385.418 591.509 385.388 591.448 385.364C591.387 385.339 591.324 385.321 591.26 385.308Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.702 365.803L570.822 388.037L591.363 392.05L596.242 369.817L575.702 365.803Z",
    fill: "url(#paint17_linear_41_1548)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 578,
    y: 372,
    width: 13,
    height: 13
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M590.53 372.735H578.961V384.868H590.53V372.735Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 579,
    y: 372,
    width: 12,
    height: 13
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M587.179 384.59C586.653 384.729 586.116 384.802 585.569 384.81C585.023 384.817 584.484 384.758 583.953 384.634L583.73 384.576H583.726C583.609 384.545 583.492 384.509 583.377 384.471C583.263 384.433 583.149 384.392 583.037 384.348C582.924 384.304 582.813 384.257 582.703 384.206C582.593 384.156 582.485 384.103 582.379 384.047C582.272 383.991 582.168 383.931 582.065 383.87C581.962 383.808 581.862 383.744 581.762 383.676C581.663 383.609 581.567 383.539 581.472 383.467C581.378 383.394 581.285 383.32 581.195 383.242C581.105 383.164 581.018 383.085 580.932 383.002C580.847 382.92 580.764 382.836 580.684 382.749C580.604 382.662 580.527 382.573 580.452 382.482C580.377 382.392 580.305 382.298 580.236 382.204C580.167 382.109 580.102 382.013 580.038 381.914C579.975 381.816 579.915 381.715 579.858 381.614C579.801 381.512 579.747 381.409 579.696 381.305C579.646 381.2 579.598 381.094 579.554 380.987C579.509 380.88 579.468 380.772 579.431 380.663C579.393 380.553 579.359 380.443 579.327 380.332C579.297 380.22 579.269 380.108 579.244 379.996C579.221 379.883 579.2 379.769 579.182 379.656C579.165 379.542 579.151 379.428 579.141 379.313C579.13 379.199 579.123 379.084 579.12 378.969C579.117 378.854 579.117 378.739 579.121 378.624C579.124 378.509 579.132 378.394 579.143 378.279C579.153 378.165 579.167 378.051 579.185 377.937C579.202 377.823 579.223 377.71 579.248 377.597C579.272 377.485 579.3 377.373 579.331 377.261C579.362 377.151 579.397 377.04 579.435 376.931C579.473 376.822 579.515 376.713 579.559 376.606C579.604 376.499 579.651 376.394 579.702 376.289C579.754 376.185 579.807 376.081 579.865 375.98C579.922 375.879 579.983 375.779 580.046 375.681C580.109 375.582 580.176 375.486 580.245 375.391C580.314 375.297 580.386 375.204 580.462 375.114C580.536 375.022 580.614 374.934 580.694 374.847C580.774 374.761 580.858 374.676 580.943 374.594C581.028 374.513 581.116 374.433 581.206 374.355C581.296 374.278 581.389 374.203 581.484 374.131C581.579 374.059 581.676 373.989 581.774 373.922C581.874 373.856 581.975 373.791 582.078 373.729C582.181 373.668 582.285 373.609 582.392 373.553C582.499 373.497 582.607 373.445 582.716 373.395C582.827 373.344 582.938 373.298 583.05 373.254C583.163 373.209 583.277 373.169 583.392 373.131C583.507 373.093 583.623 373.058 583.74 373.027C583.858 372.995 583.976 372.967 584.095 372.942C584.214 372.917 584.333 372.895 584.454 372.877C584.574 372.858 584.695 372.842 584.816 372.831C584.937 372.819 585.059 372.809 585.18 372.804C585.302 372.799 585.424 372.796 585.546 372.798C585.668 372.799 585.789 372.803 585.911 372.811C586.033 372.819 586.154 372.829 586.275 372.844C586.396 372.858 586.516 372.876 586.636 372.897C586.756 372.918 586.875 372.941 586.993 372.969C587.112 372.996 587.23 373.026 587.346 373.06C587.463 373.094 587.579 373.13 587.693 373.17C587.807 373.21 587.92 373.253 588.032 373.299C588.143 373.346 588.253 373.395 588.362 373.446C588.471 373.499 588.578 373.553 588.684 373.611C588.789 373.669 588.892 373.73 588.994 373.793C589.096 373.856 589.195 373.922 589.293 373.991C589.391 374.06 589.486 374.131 589.58 374.205C589.673 374.279 589.764 374.356 589.853 374.435C589.941 374.514 590.027 374.595 590.111 374.678L590.277 374.854C590.299 374.879 590.318 374.907 590.335 374.937C590.399 375.043 590.442 375.157 590.464 375.277C590.484 375.398 590.483 375.518 590.458 375.638C590.434 375.758 590.388 375.87 590.321 375.974C590.253 376.079 590.168 376.169 590.067 376.244C589.965 376.32 589.853 376.377 589.729 376.414C589.606 376.452 589.48 376.468 589.35 376.462C589.221 376.457 589.097 376.43 588.977 376.383C588.858 376.335 588.751 376.27 588.657 376.186L588.557 376.08C588.384 375.906 588.195 375.748 587.992 375.606C587.789 375.464 587.574 375.34 587.347 375.235C587.121 375.129 586.886 375.043 586.643 374.978C586.4 374.912 586.152 374.867 585.901 374.844C585.649 374.82 585.397 374.818 585.145 374.836C584.893 374.856 584.645 374.895 584.401 374.957C584.156 375.018 583.92 375.099 583.691 375.2C583.462 375.302 583.244 375.422 583.038 375.559C582.832 375.697 582.641 375.852 582.464 376.023C582.287 376.194 582.128 376.377 581.987 376.576C581.846 376.773 581.724 376.98 581.622 377.199C581.52 377.417 581.44 377.643 581.381 377.874C581.322 378.106 581.285 378.341 581.271 378.58C581.257 378.818 581.265 379.055 581.296 379.292C581.327 379.529 581.381 379.761 581.456 379.988C581.532 380.216 581.628 380.436 581.745 380.647C581.862 380.859 581.999 381.058 582.153 381.246C582.309 381.435 582.481 381.608 582.669 381.768C582.857 381.926 583.06 382.069 583.275 382.193C583.491 382.318 583.716 382.423 583.952 382.51C584.187 382.596 584.429 382.662 584.677 382.708C584.925 382.754 585.176 382.778 585.429 382.781C585.681 382.784 585.933 382.765 586.182 382.726C586.431 382.686 586.675 382.626 586.913 382.545C587.439 382.367 587.909 382.1 588.321 381.744C588.325 381.744 588.325 381.744 588.325 381.74L588.413 381.664C588.462 381.625 588.513 381.59 588.568 381.558C588.679 381.497 588.798 381.455 588.924 381.434C589.051 381.413 589.178 381.413 589.304 381.435C589.431 381.456 589.55 381.498 589.66 381.56C589.771 381.621 589.867 381.699 589.948 381.793C590.029 381.888 590.091 381.992 590.132 382.107C590.173 382.222 590.193 382.34 590.19 382.461C590.186 382.583 590.16 382.7 590.112 382.813C590.064 382.925 589.997 383.027 589.911 383.116C589.874 383.159 589.833 383.196 589.787 383.229H589.783C589.031 383.881 588.164 384.335 587.179 384.59Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.861 375.411L588.012 368.371L595.741 382.203L581.59 389.242L573.861 375.411Z",
    fill: "url(#paint18_linear_41_1548)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 582,
    y: 376,
    width: 10,
    height: 5
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M591.314 376.963H582.883V380.639H591.314V376.963Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_41_1548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_41_1548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 582,
    y: 377,
    width: 10,
    height: 4
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M582.992 378.558C583.006 378.46 583.029 378.362 583.06 378.268C583.092 378.172 583.132 378.08 583.179 377.991C583.227 377.902 583.283 377.818 583.346 377.738C583.409 377.657 583.479 377.583 583.555 377.514C583.632 377.445 583.714 377.383 583.801 377.327C583.888 377.271 583.98 377.222 584.077 377.181C584.173 377.14 584.272 377.106 584.375 377.081C584.477 377.056 584.581 377.038 584.686 377.03C584.791 377.02 584.896 377.02 585.002 377.028C585.108 377.035 585.211 377.052 585.314 377.076C585.416 377.101 585.516 377.133 585.612 377.173C585.71 377.213 585.802 377.261 585.89 377.316C585.979 377.371 586.061 377.432 586.139 377.501C586.215 377.569 586.286 377.643 586.35 377.723C586.414 377.802 586.47 377.886 586.519 377.974C586.568 378.062 586.609 378.154 586.642 378.249C587.012 378.446 587.521 378.566 588.089 378.566C588.574 378.566 589.022 378.475 589.373 378.326C589.463 378.181 589.585 378.068 589.74 377.987C589.816 377.945 589.897 377.914 589.983 377.893C590.033 377.881 590.085 377.874 590.138 377.871C590.281 377.858 590.42 377.873 590.557 377.918C590.693 377.962 590.812 378.031 590.917 378.125H590.92L590.994 378.202C591.033 378.243 591.067 378.288 591.094 378.337C591.126 378.39 591.153 378.446 591.173 378.505C591.194 378.563 591.208 378.623 591.217 378.685C591.224 378.746 591.227 378.808 591.221 378.869C591.217 378.93 591.206 378.991 591.188 379.05C591.171 379.11 591.148 379.167 591.118 379.223C591.089 379.277 591.054 379.33 591.014 379.378C590.974 379.427 590.929 379.471 590.88 379.512C590.83 379.552 590.776 379.587 590.72 379.618C590.539 379.714 590.344 379.754 590.138 379.735C590.085 379.73 590.033 379.721 589.983 379.709C589.822 379.671 589.681 379.599 589.559 379.494L589.447 379.381C589.447 379.379 589.445 379.378 589.443 379.378L589.373 379.279C589.022 379.126 588.574 379.035 588.089 379.035C587.521 379.035 587.012 379.156 586.642 379.355C586.604 379.459 586.558 379.559 586.501 379.654C586.444 379.749 586.379 379.839 586.305 379.923C586.231 380.007 586.149 380.084 586.06 380.153C585.97 380.223 585.875 380.284 585.774 380.337C585.673 380.39 585.567 380.434 585.458 380.469C585.347 380.504 585.236 380.529 585.121 380.544C585.006 380.559 584.891 380.564 584.775 380.56C584.66 380.555 584.546 380.54 584.432 380.515C584.32 380.49 584.21 380.456 584.104 380.412C583.998 380.369 583.897 380.315 583.801 380.254C583.705 380.193 583.616 380.124 583.534 380.047C583.452 379.97 583.377 379.887 583.312 379.797C583.246 379.707 583.189 379.613 583.142 379.513C583.094 379.413 583.057 379.31 583.029 379.204C583.002 379.098 582.985 378.99 582.979 378.881C582.972 378.772 582.977 378.663 582.992 378.555V378.558Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_41_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.887 375.474L591.972 380.418L583.312 382.111L582.226 377.166L590.887 375.474Z",
    fill: "url(#paint19_linear_41_1548)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_1548",
    x1: 723.816,
    y1: 487.216,
    x2: 727.421,
    y2: 487.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_1548",
    x1: 723.812,
    y1: 474.307,
    x2: 730.898,
    y2: 474.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_41_1548",
    x1: 727.903,
    y1: 483.325,
    x2: 729.502,
    y2: 483.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_41_1548",
    x1: 728.84,
    y1: 492.232,
    x2: 731.438,
    y2: 492.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_41_1548",
    x1: 730.23,
    y1: 464.223,
    x2: 749.256,
    y2: 464.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_41_1548",
    x1: 728.051,
    y1: 443.119,
    x2: 752.675,
    y2: 443.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_41_1548",
    x1: 729.23,
    y1: 496.408,
    x2: 737.989,
    y2: 496.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_41_1548",
    x1: 705,
    y1: 436.916,
    x2: 726.539,
    y2: 436.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_41_1548",
    x1: 710.773,
    y1: 460.573,
    x2: 726.416,
    y2: 460.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_41_1548",
    x1: 716.328,
    y1: 488.434,
    x2: 727.288,
    y2: 488.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_41_1548",
    x1: 728.843,
    y1: 498.561,
    x2: 728.843,
    y2: 547.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_41_1548",
    x1: 260.766,
    y1: 85.1931,
    x2: 561.232,
    y2: 85.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_41_1548",
    x1: 305.838,
    y1: 131.07,
    x2: 308.132,
    y2: 131.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_41_1548",
    x1: 292.55,
    y1: 121.603,
    x2: 301.402,
    y2: 149.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_41_1548",
    x1: 290.759,
    y1: 140.016,
    x2: 304.732,
    y2: 131.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_41_1548",
    x1: 305.327,
    y1: 139.034,
    x2: 296.71,
    y2: 140.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_41_1548",
    x1: 592.838,
    y1: 374.07,
    x2: 595.132,
    y2: 374.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_41_1548",
    x1: 579.55,
    y1: 364.603,
    x2: 588.402,
    y2: 392.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_41_1548",
    x1: 577.759,
    y1: 383.016,
    x2: 591.732,
    y2: 374.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_41_1548",
    x1: 592.327,
    y1: 382.034,
    x2: 583.71,
    y2: 383.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 530,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_41_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(288 126)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_41_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(575 369)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroHireDedicatedHeroDevelopers);
export default __webpack_public_path__ + "static/media/hero-hire-dedicated-hero-developers.1c9a5aa58a75dda7c37cfb5fab30d446.svg";
export { ForwardRef as ReactComponent };